import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

export const baseTranslationUK = {
  title: 'Вихідні дані',
  subtitle: 'Відомості відповідно до § 5 DDG (німецький Закон про цифрові послуги)',
  serviceProvider: 'Постачальник послуг',
  contactTitle: 'Контакти',
  addressLabel: 'Адреса',
  contactLabel: 'Адреса електронної пошти',
  professionalTitle: 'Відомості про компанію',
  professionLabel: 'Організаційно-правова форма',
  businessTypeLabel: 'Вид діяльності',
  taxTitle: 'Податкова інформація',
  liabilityTitle: 'Застереження щодо відповідальності',
  contentLiabilityTitle: 'Відповідальність за вміст',
  contentLiability: 'Як постачальник послуг ми відповідно до § 7 абз. 1 DDG несемо відповідальність за власний вміст цих сторінок згідно із загальними законами. Водночас відповідно до §§ 8–10 DDG ми як постачальник послуг не зобов’язані контролювати передану або збережену сторонню інформацію чи з’ясовувати обставини, які вказують на протиправну діяльність.',
  linkLiabilityTitle: 'Відповідальність за посилання',
  linkLiability: 'Наш сайт містить посилання на зовнішні вебсайти третіх осіб, на вміст яких ми не маємо впливу. Тому ми не можемо брати на себе жодних гарантій щодо цього стороннього вмісту. За вміст сторінок, на які ведуть посилання, завжди відповідає їхній постачальник або оператор. На момент розміщення посилань ці сторінки було перевірено на можливі порушення закону. Протиправного вмісту на момент розміщення посилань виявлено не було.',
  copyrightTitle: 'Авторське право',
  copyright: 'Вміст і твори, створені операторами сайту на цих сторінках, підпадають під дію німецького авторського права. Відтворення, опрацювання, поширення та будь-яке використання поза межами авторського права потребують письмової згоди відповідного автора або творця. Завантаження та копіювання цих сторінок дозволені лише для приватного, некомерційного використання.'
};

export const localeUK = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Головна',
    team: 'Команда',
    events: 'Події',
    finance: 'Фінансовий ШІ',
    teaching: 'Навчання',
    agenticdev: 'IDD / агентне програмування',
    iddLegacy: 'Модернізація застарілого ПЗ',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Анонімізація',
    quantum: 'Квантовий ШІ',
    login: 'Увійти',
    openApp: 'Відкрити застосунок',
    account: 'Обліковий запис',
    admin: 'Адмін-панель',
    logout: 'Вийти',
    languageNames: {
      en: 'Англійська',
      de: 'Німецька',
      nl: 'Нідерландська',
      fr: 'Французька',
      it: 'Італійська',
      es: 'Іспанська',
      sv: 'Шведська',
      fi: 'Фінська',
      ja: 'Японська',
      uk: 'Українська',
      pl: 'Польська',
      bg: 'Болгарська'
    }
  },
  admin: {
    datalake: {
      loading: "Завантаження …",
      loadFailed: "Data lake недоступний",
      refresh: "Оновити",
      generatedAt: "Станом на",
      notRolled: "Цей розділ ще не розгорнуто в бекенді. Щойно нові кінцеві точки запрацюють, тут з'явиться виміряний стан.",
      loadMore: "Завантажити ще",
      yes: "так",
      no: "ні",
      none: "немає",
      close: "Закрити",
      summaryTitle: "Дві гіпотези, один верстат",
      summaryBody: "Гіпотеза архітектури каже: математична посудина визначає, чим може стати модель — вона описана на сторінці LLM-статті. Гіпотеза даних каже: лише пов'язані, верифіковані навчальні дані наповнюють цю посудину — їй служить ця сторінка. Автопілот безперервно наповнює сховище даних, запускає навчання, щойно план даних зі статті досягнуто в кожній галузі німецькою та англійською, вимірює результат бенчмарк-сюїтою та публікує модель приватно на HuggingFace. Кожне число тут виміряне або позначене як налаштоване значення.",
      summaryArchButton: "До гіпотези архітектури (LLM-стаття)",
      apTitle: "Автопілот",
      tpTitle: "Шлях до старту навчання",
      tpSubtitle: "Де зараз автопілот: кожен крок до запущеного навчання зі станом, часом і прогресом.",
      tpNow: "Зараз",
      tpStep: "Крок",
      tpOf: "з",
      tpSince: "з",
      tpFor: "триває",
      tpHeartbeat: "останній сигнал життя",
      tpDone: "готово",
      tpRunning: "триває",
      tpWaiting: "чекає",
      tpFailed: "невдало",
      tpSkipped: "пропущено",
      tpProgress: "Прогрес",
      tpRows: "рядків",
      tpRate: "за секунду",
      tpRemaining: "орієнтовний залишок часу",
      tpEstimateNote: "оцінка з виміряних лічильників",
      tpPhaseReading: "читає пакет даних",
      tpPhaseAdmission: "допуск (дублікати, ентропія)",
      tpPhaseEncoding: "токенізація",
      tpNoTiming: "Ця версія рушія ще не повідомляє часи.",
      tpBlockers: "Блокери та помилки",
      tpNone: "Блокерів немає.",
      trTitle: "Тренувальний запуск (наживо)",
      trSubtitle: "Читається безпосередньо з каталогу запуску тренера — працює й під час перезапуску worker-а.",
      trNoRun: "Ще немає тренувального запуску з даними про прогрес.",
      trStateTraining: "тренується",
      trStateStarting: "запускається",
      trStateFinished: "завершено",
      trStateSilent: "мовчить уже {age}",
      trStep: "Крок",
      trOf: "з",
      trRemaining: "Залишок часу (оцінка за виміряною швидкістю)",
      trSecondsPerStep: "с на крок",
      trProgress: "Прогрес запланованих кроків",
      trRun: "Запуск",
      trResumed: "продовжено з кроку {step}",
      trVersion: "Версія тренувальних даних",
      trModel: "Модель",
      trTokensPerSecond: "Токенів/с",
      trTokensSeen: "Опрацьовано токенів",
      trVram: "Пам'ять GPU",
      trCap: "ліміт",
      trLastHeartbeat: "Останній heartbeat",
      trAgo: "{age} тому",
      trShardReads: "Читання шардів локально / через worker",
      trLossTitle: "Динаміка втрат (loss)",
      trLossTotal: "Загалом",
      trLossNtp: "Наступний токен",
      trLossMtp: "Багатотокенний",
      trChartEmpty: "Кроків ще не повідомлено.",
      trAxisNote: "По горизонталі: крок тренування, по вертикалі: втрати (натуральний логарифм). Наведіть курсор на криву, щоб побачити значення кроку.",
      trValue: "Значення",
      trCurrentValue: "поточне",
      trPoints: "усього {count} точок вимірювання",
      trStages: "Етапи навчального плану",
      trStageFoundation: "Основа (сирий текст)",
      trStageCapability: "Здібності",
      trStageAnneal: "Anneal",
      trStageCurrent: "триває",
      trStageDone: "завершено",
      trStageAhead: "попереду",
      trShards: "шардів",
      trRows: "рядків",
      trCheckpoint: "Найновіший checkpoint",
      trCheckpointNone: "ще немає",
      trCheckpoints: "Повні checkpoints на диску",
      trCheckpointEvery: "кожні {minutes} хв",
      trKernels: "Активні ядра (kernels)",
      trDeviations: "Відхилення",
      trBlockStorage: "Копія в block storage",
      trBlockStorageNone: "ще немає — перша з'явиться після першого checkpoint",
      trUploading: "вивантаження: крок {step}",
      treeCkRun: "Тренувальний запуск",
      treeCkCopy: "Checkpoint у block storage, скопійовано {time}",
      treeCkLocal: "Checkpoint на диску сервера",
      treeCkUploading: "саме копіюється в block storage",
      trKpiProgress: "Прогрес",
      trKpiTokens: "Токени",
      trKpiThroughput: "Пропускна здатність",
      trKpiLoss: "Втрати",
      trKpiLr: "Швидкість навчання",
      trKpiGpu: "Пам'ять GPU",
      trEndAt: "кінець приблизно {time}",
      trSeenPlanned: "опрацьовано / заплановано",
      trBest: "найкраща {value}",
      trHourAgo: "{value} порівняно з 1 год тому",
      trPerplexity: "перплексія {value}",
      trPhaseWarmup: "розігрів",
      trPhaseCosine: "косинусне зменшення",
      trPhaseStable: "стабільна фаза",
      trPhaseDecay: "охолодження",
      trKpiEpoch: "Епоха",
      trEpochValue: "{epoch} з {epochs}",
      trPlanTitle: "План навчання",
      trPlanExplain: "Розігрів до пікової швидкості навчання, потім стала швидкість упродовж чотирьох змішаних епох корпусу; фаза охолодження навчає на найякіснішій суміші (зразки навичок, підручникові тексти, anneal) і знижує швидкість навчання до нуля.",
      trPlanPhase: "Фаза",
      trPlanStableSteps: "Заплановані кроки стабільної фази",
      trPlanDecay: "Охолодження",
      trPlanDecayAhead: "з кроку {step} · приблизно через {time}",
      trPlanDecayAheadNoTime: "з кроку {step}",
      trPlanDecayRunning: "з кроку {step} · {steps} кроків до швидкості навчання нуль",
      trPlanTokensPerStep: "Токени на крок оптимізації",
      trPlanTokensPerStepValue: "{tokens} ({accum} мікропакетів)",
      trPlanRecompute: "Перерахунок активацій",
      trPlanRecomputeOn: "увімкнено – виміряно швидше з більшим мікропакетом",
      trPlanRecomputeOff: "вимкнено – виміряно швидше без",
      trPlanFim: "Документи у форматі fill-in-the-middle досі",
      tbTitle: "Підручникова програма",
      tbSubtitle: "Foundation-тексти, переписані моделями-вчителями як підручниковий текст; кожне число і кожна власна назва мусять бути в джерелі.",
      tbTokens: "Підручникові токени",
      tbTokensSub: "{pct} % від мети {target}",
      tbSamples: "Прийняті переписування",
      tbJobs: "Завершені завдання",
      tbTeacher: "Токени вчителя на підручниковий токен",
      tbCost: "Вартість на мільйон підручникових токенів",
      tbCostNone: "шлюз не повідомляє вартість; рахуються токени вчителя",
      tbExplain: "Працює паралельно з навчанням; пізніші епохи й охолодження читають те, що запечатано до того часу.",
      trThroughputTitle: "Пропускна здатність (токенів/с)",
      trCurriculumTitle: "Навчальний план",
      trStageTokens: "{tokens} токенів",
      trStageBegins: "починається з кроку {step}",
      trPlanWarningLabel: "Увага",
      trPlanWarning: "Запуск закінчується після {max} кроків на етапі «{stage}» — дані здібностей починаються лише з кроку {cap}. Повний прохід потребував би {steps} кроків (≈ {days} днів).",
      trPlanOk: "Заплановані кроки сягають етапу «{stage}».",
      trCheckpointsTitle: "Checkpoints",
      trNextCheckpoint: "Наступний checkpoint",
      trInSpan: "через {span}",
      trResumes: "Відновлення",
      trNoResume: "немає",
      trConfig: "Конфігурація",
      trHealth: "Стан",
      trMicroBatch: "Мікропакет / токенів на крок",
      trSeqLen: "Довжина послідовності",
      trLrPlan: "План швидкості навчання",
      trLrPlanValue: "пік {lr}, розігрів {warmup} кроків, косинус до кроку {max}",
      trSpikes: "Сплески втрат (остання година)",
      trProgressSub: "крок {step} з {max} · тренується вже {elapsed}",
      trTokensSub: "із {planned} запланованих",
      trPathTrainingDetail: "{pct} % · крок {step} з {max} · кінець приблизно {end}",
      trReadinessRunning: "Тренування триває: виконано {pct} % (крок {step} з {max}), втрати {loss}, кінець приблизно {end}.",
      tdvDraftsHistory: "Старіші чернетки, ніколи не запечатані ({count})",
      runsHistory: "Перервані та невдалі запуски ({count})",
      trAxisStep: "Крок тренування",
      trAxisLoss: "Втрати (натуральний логарифм)",
      trCountdown: "{d} д {h} год {m} хв {s} с",
      trTimerWaiting: "Таймер з'явиться після перших вимірювань.",
      trTimerStageEnds: "Етап «{stage}» завершиться через",
      trTimerAt: "о {time}",
      trTimerNext: "Далі «{stage}»: {span}, з {time}",
      trTimerRunEnds: "Запуск завершиться через {span} (о {time})",
      trStepTimeSub: "{wall} с на крок виміряно · обчислення {compute} с",
      trEtaTitle: "Залишок часу за виміряною тривалістю кроку",
      trEtaEpochEnds: "Епоха {epoch} з {epochs} завершиться через",
      trEtaEpochAt: "о {time} (крок {step})",
      trEtaNextEpoch: "Епоха {epoch}: з {time} (крок {step})",
      trEtaDecay: "Фаза охолодження почнеться через {span} (о {time}, крок {step})",
      trEtaBasis: "Основа: {wall} с на крок, середнє за останні {n} кроків без {pauses} пауз (перезапуск, простій); час обчислень за даними тренера {compute} с на крок.",
      devTitle: "Відхилення від креслення",
      devNone: "Відхилень немає — запуск повністю відповідає кресленню.",
      devPlanned: "заплановано",
      devLimit: "обмеження",
      devSeqLen: "Довжина контексту",
      devSeqLenText: "Тренується з контекстом {trained} токенів замість {spec}, передбачених кресленням. Довгий контекст додасться на пізнішому етапі.",
      devFim: "Заповнення прогалин (FIM)",
      devFimText: "Ціль заповнення прогалин ({rate} % блоків) оголошена в кресленні, але в цьому запуску ще не активна.",
      devTermination: "Зонд завершення",
      devTerminationText: "Зонд завершення — не ціль тренування, а окремий режим після тренування; він запускається пізніше на готовому checkpoint.",
      devDecision: "Ціль рішень",
      devDecisionText: "Ціль рішень активна, але на етапах після тренування цього запуску не надійшло жодної позначки рішення.",
      devKernelOff: "Прискорення вимкнено",
      devKernelUnverifiedText: "Ядро «{kernel}» не підтверджене зондом і працює як стандартне обчислення.",
      devKernelUnavailableText: "Ядро «{kernel}» недоступне на цій карті і працює як стандартне обчислення.",
      devKernelFellBackText: "Ядро «{kernel}» під час запуску повернулося до стандартного обчислення ({reason}).",
      devOptimizer: "Оптимізатор",
      devOptimizerText: "Стани оптимізатора в bfloat16 замість 8 біт (bitsandbytes недоступний) — більше пам'яті, та сама математика.",
      devScale: "Розмір моделі",
      devScaleText: "Модель створено на {scale} % від розміру в кресленні, бо повний розмір не вмістився у виміряну пам'ять.",
      devMediaHeads: "Медіаголови",
      devMediaHeadsText: "Голови для зображень/аудіо не натреновані, бо дані не містять медіатокенів — для текстової гілки це заплановано.",
      devVision: "Шлях зображень",
      devVisionText: "Шлях зображень побудовано, але натреновано на нулі зображень, бо дані їх не містять.",
      devOther: "Інше",
      trStageShare: "{pct} % цього етапу виконано",
      cap_tool_calling: "Виклики інструментів",
      cap_deep_reasoning: "Глибоке міркування",
      cap_software_engineering: "Розробка ПЗ",
      cap_office_finance: "Офіс і фінанси",
      cap_doc_understanding: "Розуміння документів",
      tpExplainThresholds: "Для кожної здібності обраної гілки в data lake має бути достатньо перевірених прикладів. Ціль і вимір показані тут для кожної здібності.",
      tpThresholdsDetail: "{met} із {total} здібностей досягли цілі",
      tpThresholdRow: "{measured} прикладів",
      tpForeignThresholds: "Не для цієї гілки: {list} — належить іншій гілці й нічого не блокує.",
      tpStepTokenizerReleaseExplain: "Токенізатор перетворює текст на числа. Його фіксують один раз і повідомляють архітектурі, щоб дані й модель говорили однією мовою.",
      tpStepTokenizeTdvExplain: "Усі перевірені приклади перекладаються в числові послідовності зафіксованим токенізатором.",
      tpStepTokenizeCorpusExplain: "Весь сирий текст data lake перекладається в числові послідовності — маса для основи.",
      tpStepTdvCreateExplain: "З усіх токенізованих даних збирається фіксована версія тренувальних даних (TDV) з навчальним планом і виміряним обсягом токенів.",
      tpStepTdvSealExplain: "Версію роблять незмінною і копіюють з описом у block storage.",
      tpStepCompatExplain: "Дванадцять правил перевіряють, чи сумісні версія й архітектура (токенізатор, довжина контексту, цілі, пам'ять). Усі мають бути зеленими.",
      tpStepVramExplain: "Вимірює на карті, чи достатньо вільної пам'яті GPU для заявленої потреби.",
      tpVramDetail: "{free} ГБ вільно, {need} ГБ потрібно",
      tpStepTrainStartExplain: "Автопілот запускає тренування, щойно всі передумови виконані.",
      tpStepTrainingExplain: "Запуск тренується самостійно з checkpoint кожні 30 хвилин і сам продовжує після будь-якої перерви. Подробиці на сторінці «Тренування та публікація».",
      tpVramRunning: "карту використовує поточне тренування (потрібно {need} ГБ); виконано на старті",
      trPathTrainingDetailNoEnd: "{pct} % · крок {step} з {max}",
      srTitle: "Готовність даних за гілками моделі",
      srSubtitle: "Поки одна гілка тренується, data lake далі готує дані інших — аж до їхньої власної запечатаної версії, без старту тренування.",
      srTrainingNow: "тренується зараз",
      srSelected: "вибрано",
      srDataReady: "дані готові",
      srPreparing: "готуються",
      srModalities: "вхід: {in} · вихід: {out}",
      srThresholds: "цілі: {met} із {total} досягнуто",
      srCorpus: "Токенізований корпус",
      srCorpusValue: "{tokens} токенів у {shards} пакетах даних",
      srVersion: "Найновіша версія",
      srNoVersion: "ще немає",
      srLacking: "Ще бракує",
      srLacksNothing: "нічого — версія чекає на свою гілку",
      srLackThresholds: "цілі не досягнуто",
      srLackCodec: "кодек зображень/аудіо не випущено",
      srLackTokenizer: "токенізатор не повідомлено",
      srLackVersion: "немає запечатаної версії",
      srSelectedNote: "Ця гілка зараз тренується; її шлях показано вище.",
      srSelectedIdleNote: "Цю гілку вибрано для наступного тренування; її шлях показано вище.",
      srUnselectedNote: "Ця гілка не запускає тренування, поки обрано іншу — її дані все одно готуються повністю.",
      modText: "текст",
      modImage: "зображення",
      modAudio: "аудіо",
      modVideo: "відео",
      tpStepThresholds: "Досягнення цілей",
      tpStepPlan: "Досягнення плану даних зі статті",
      tpExplainPlan: "Стаття визначає, скільки унікальних, перевірених токенів потрібно кожній галузі. Німецька та англійська несуть кожна щонайменше половину; код рахується без мови. Рахуються допущені токени після видалення дублікатів, а не сира оцінка.",
      tpPlanDetail: "Досягнуто {met} з {total} галузей",
      tpPlanRowLang: "{have} / {target} · німецька {de} / {half} · англійська {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "відкрито: {langs}",
      tpLangDe: "німецька",
      tpLangEn: "англійська",
      tpPlanProvisional: "Попередньо пораховано досі використовуваним токенізатором; вирішує щойно навчений.",
      tpStepOwnTokenizer: "Власний токенізатор гілки",
      tpStepOwnTokenizerExplain: "Гілка навчається з власним токенізатором, вивченим на збалансованому корпусі з кодом. Лише в його токенах план даних рахується остаточно.",
      tpPlanCat_knowledge: "Знання",
      tpPlanCat_code: "Код",
      tpPlanCat_mathematics: "Математика",
      tpPlanCat_domain: "Фахові тексти",
      tpPlanCat_textbook: "Підручник",
      tpPlanCat_agentic: "Агентні приклади",
      tpPlanFlow: "приплив {rate} за годину",
      tpPlanEtaDays: "залишилося близько {n} днів",
      tpPlanEtaHours: "залишилося близько {n} годин",
      tpPlanNoFlow: "немає припливу за останні 24 години",
      tpPlanBinding: "вузьке місце",
      tpBind_download: "завантаження",
      tpBind_allowance: "денна квота block storage",
      tpBind_ingest: "приймання",
      tpBind_teachers: "моделі-вчителі",
      thrPlanTitle: "Приклади за здібністю (виміряні)",
      thrPlanNote: "Цілі цієї гілки визначає її стаття: план даних за галузями, німецькою та англійською, на шляху до старту навчання. Пороги за здібністю діють лише для гілок без плану даних; тут показано, що містить кожна здібність за вимірюванням.",
      thrPlanRow: "{samples} прикладів · {tokens} токенів",
      srDataPlan: "План даних зі статті: досягнуто {met} з {total} галузей",
      srLackDataPlan: "план даних не досягнуто",
      srPlanOpen: "відкрито: {areas}",
      tpBind_source: "немає джерела цією мовою",
      tpBind_paused: "завантаження призупинено",
      tdvPlanEmpty: "Ще немає версії даних активної специфікації. Автопілот збудує й запечатає її, щойно план даних зі статті буде досягнуто.",
      compatPlanNone: "Ще немає перевірки: версію активної специфікації перевіряють під час запечатування.",
      mixPlanTitle: "Суміш згідно зі статтею",
      mixPlanNote: "Кожен крок навчання бере галузі в цих фіксованих частках; фаза згасання підвищує високоякісну частку до половини. Цілі суміші за здібністю діють лише для гілок без плану даних.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Ситуація",
      sitSubtitle: "Де навчання з одного погляду: чого ще бракує в кожній галузі статті, що працює зараз і що буде далі.",
      sitHeadlineDays: "Навчання може стартувати щонайраніше приблизно через {time}; найдовше триває {area} (вузьке місце: {bottleneck}).",
      sitHeadlineBlocked: "Так план даних не досягти: {items} не має джерела. Над цим працюють: пошук відкритих наборів даних або перевірений переклад.",
      sitHeadlineReached: "План даних досягнуто; далі токенізатор, нова токенізація, запечатування й перевірки.",
      sitHeadlineUnknown: "Приплив решти ще не виміряно.",
      sitHold: "Старт додатково зупинено, доки кожен складник не перевірено.",
      sitArea: "Галузь",
      sitTotal: "Разом",
      sitFlow: "Приплив",
      sitLeft: "Лишилося",
      sitBottleneck: "Вузьке місце",
      sitNoLanguage: "без мови",
      sitNoSource: "немає джерела",
      sitReached: "досягнуто",
      sitDays: "{n} днів",
      sitHours: "{n} год",
      sitPerHour: "{value} за годину",
      sitPerHourTokens: "{value} токенів за годину",
      sitRunningTitle: "Що працює зараз",
      sitDownloads: "Завантаження",
      sitIngest: "Обробка на текстові фрагменти",
      sitTokenize: "Токенізація",
      sitGenerate: "Генерація моделями-вчителями",
      sitIdle: "у спокої",
      sitNextTitle: "Що далі",
      sitNextSteps: "Навчити токенізатор з кодом → заново токенізувати весь корпус → запечатати версію → перевірки → старт навчання",
      sitProvisional: "Обсяги пораховано попередньо досі використовуваним токенізатором; остаточно рахує щойно навчений.",
      tpPlanSeeSituation: "Галузі, мови й залишковий час — у ситуації вище.",
      sitHeadlineBlocks: "Навчання ще не може стартувати: бракує складників, які ще треба збудувати ({items}). Тим часом дані зростають.",
      sitDuration: "Тривалість навчання: близько {days} днів для {budget} токенів при виміряних {rate} токенах за секунду на тій самій мережі.",
      sitBlocksTitle: "Складники навчання",
      sitStateNotBuilt: "ще не збудовано",
      sitStateWaiting: "чекає",
      sitStateReady: "готово",
      sitBlockWaitsFor: "очікує: {items}",
      sitBenchProgress: "{made} з {total} перевірених завдань",
      sitBlockParts: "збудовано: {built} · відкрито: {open}",
      part_graph_bundles: "пов’язані документи",
      part_repository_bundles: "цілі репозиторії",
      part_long_context: "довгий контекст",
      part_fine_tuning: "донавчання",
      part_reinforcement_learning: "навчання з підкріпленням",
      part_real_folding: "справжнє згортання контексту",
      sitBlock_data: "Дані за планом статті",
      sitBlock_tokenizer: "Токенізатор з кодом",
      sitBlock_bench: "Бенчмарк-набір статті",
      sitBlock_trainer: "Тренер: етапи вікна, фіксований бюджет, фіксована суміш",
      sitBlock_bundles: "Пакети: пов'язані документи й цілі репозиторії",
      sitBlock_post_training: "Донавчання: довгий контекст, тонке налаштування, навчання з винагородою",
      tpStepTokenizerRelease: "Випуск токенізатора",
      tpStepTokenizeTdv: "Токенізація навчальних прикладів",
      tpStepTokenizeCorpus: "Токенізація корпусу",
      tpStepTdvCreate: "Створення версії даних",
      tpStepTdvSeal: "Запечатування версії даних",
      apAfterSealLabel: "Автоматично продовжувати після запечатування",
      apAfterSealOn: "УВІМК",
      apAfterSealOff: "ВИМК",
      apAfterSealConfirmOn: "Автоматично продовжувати після запечатування? Шлях до старту навчання тоді йде без паузи: перевірка сумісності, перевірки GPU та старт навчання.",
      apAfterSealConfirmOff: "Знову зупинятися після запечатування? Автопілот тоді ставиться на паузу для перегляду після запечатування версії даних.",
      apAfterSealTurnedOn: "Шлях до старту навчання автоматично продовжується після запечатування.",
      apAfterSealTurnedOff: "Автопілот зупиняється після запечатування.",
      apAfterSealWaiting: "Версію даних запечатано – автопілот на паузі для перегляду.",
      apAfterSealStep: "Перегляд запечатаної версії даних",
      apAfterSealHint: "Після запечатування всі дані оброблено й збережено в блоковому сховищі. Коли перемикач вимкнено, автопілот ставиться там на паузу для перегляду; увімкнено – шлях продовжується автоматично.",
      tpStepCompat: "Перевірка сумісності",
      tpStepVram: "VRAM-проба",
      tpStepTrainStart: "Старт навчання",
      tpStepTraining: "Навчання триває",
      apSubtitle: "Один перемикач для всього циклу: збирати, обробляти й пов'язувати дані, генерувати приклади, навчати, щойно план даних зі статті досягнуто, перевіряти бенчмарками й публікувати приватно. Кожне блокування називається, а не приховується.",
      apOn: "Автопілот УВІМК",
      apOff: "Автопілот ВИМК",
      apTurnOn: "Увімкнути автопілот",
      apTurnOff: "Вимкнути автопілот",
      apConfirmOn: "Увімкнути автопілот? Він безперервно поповнює дані до запечатаної версії даних; потім ставиться на паузу для перегляду, якщо не ввімкнено «Автоматично продовжувати після запечатування».",
      apConfirmOff: "Вимкнути автопілот? Поточна робота завершиться контрольовано; нічого не буде відкинуто.",
      apEnabled: "Автопілот увімкнено",
      apDisabled: "Автопілот вимкнено",
      apPause: "Призупинити",
      apResume: "Продовжити",
      apResumed: "Автопілот продовжено",
      apPausedNote: "Автопілот призупинено",
      apPausedPill: "призупинено",
      apPhaseLabel: "Фаза",
      apPhaseSince: "з {time}",
      apCycleId: "Цикл",
      apBlockedLabel: "Заблоковано",
      apCycleTitle: "Поступ поточного циклу",
      apCycleEmpty: "Немає активного циклу.",
      colPhase: "Фаза",
      colPending: "Очікує",
      colRunning: "Виконується",
      colDone: "Готово",
      colFailed: "Невдало",
      thrTitle: "Пороги за здатностями",
      thrSubtitle: "Від цих обсягів автопілот запечатує версію навчальних даних і запускає навчання; смуги показують виміряний поступ.",
      thrMet: "досягнуто",
      thrNotMet: "відкрито",
      thrDefault: "попередньо заданий стандарт",
      thrForeign: 'не для обраного напряму',
      staleSince: 'Воркер зараз не відповідає — останній виміряний стан від',
      staleHint: 'Автопілот працює далі; вигляд оновиться, щойно воркер знову відповість.',
      idxTitle: 'Векторний індекс і дедуплікація',
      idxSubtitle: 'Власний HNSW-індекс озера для звʼязування графа та виміряне видалення дубльованих chunk-шардів.',
      idxConfigured: 'Індекс налаштовано',
      idxReachable: 'Індекс доступний',
      idxPoints: 'Точки індексу',
      idxBackfill: 'Наповнення з таблиці embeddings',
      idxBackfillDone: 'завершено',
      idxBackfillOpen: 'триває / відкрито',
      ddLastPass: 'Останній прохід дедуплікації',
      ddChecked: 'перевірені активи',
      ddDropped: 'видалені дубльовані шарди',
      ddRows: 'видалені рядки chunk',
      ddRemaining: 'кандидати, що лишилися',
      ddNone: 'проходу ще не було',
      gsTitle: 'Етапи графа',
      gsSubtitle: 'Teacher-етапи графа — embedding і видобування тверджень — служать синтезу прикладів із графа, тому беруть chunk у порядку рангів і вшир по активах: ранг 0 — документи власника та імпорти з інструментів, ранг 1 — експертні знання (наука, техніка, книги, міркування, German Commons, Wikipedia), ранг 2 — загальний текст (Wikisource, Gutenberg, вебкорпуси, транскрипти), ранг 3 — код (лише embedding, твердження з нього не видобуваються). Базова маса потрапляє до корпусу токенів без teacher-проходу.',
      gsMeasuredAt: 'Виміряно о',
      gsRanksTitle: 'Порядок рангів',
      gsRanksEmpty: 'План рангів ще не повідомлено.',
      gsColRank: 'Ранг',
      gsColLabel: 'Клас джерела',
      gsColSources: 'Джерела',
      gsColAssets: 'Активи',
      gsColPendingExtract: 'Очікує видобування',
      gsColPendingEmbed: 'Очікує embedding',
      gsRankOwner: 'Документи власника та імпорти з інструментів',
      gsRankExpert: 'Експертні знання',
      gsRankGeneral: 'Загальний текст',
      gsRankCode: 'Код (лише embedding)',
      gsRankShort: 'ранг {n}',
      gsLoopsTitle: 'Останній раунд кожного циклу',
      gsColLoop: 'Цикл',
      gsColSource: 'Джерело',
      gsColChunks: 'Оброблено chunk',
      gsColClaims: 'Твердження',
      gsColEdges: 'Ребра',
      gsColSeconds: 'Секунди',
      gsColLast: 'Останній раунд',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Видобування тверджень',
      gsLoopLink: 'Звʼязування',
      gsUngrounded: '{n} без підтвердження',
      gsNoRound: 'раунду ще не було',
      gsClaims: 'Тверджень усього',
      gsAssetsWithClaims: 'Активи з твердженнями',
      gsDangling: 'Осиротілі chunk-вузли',
      gsStuck: 'Застряглі активи (в обробці без активного ingest)',
      gsConcurrency: 'Паралельність видобування',
      gsOrphansLast: 'Останній прохід очищення',
      gsOrphansNone: 'проходу ще не було',
      gsOrphansStatusCleaned: 'очищено',
      gsOrphansDropped: 'вузлів видалено',
      gsOrphansRemaining: 'залишилось',
      gsOrphansHint: 'Тут нічого робити: автопілот сам планує обмежений прохід очищення, доки існують chunk-вузли без shard. Підсумок показує останній прохід.',
      thrSamplesBar: "Приклади",
      thrTokensBar: "Токени (оцінка)",
      thrNoMinimum: "виміряно, без мінімуму",
      thrEditTitle: "Редагувати пороги",
      thrEditSubtitle: "Збереження повністю замінює всі пороги; попередньо задані стандарти діють лише доти, доки тут не встановлено власні значення.",
      thrMinSamples: "Мін. приклади",
      thrMinTokens: "Мін. токени (оцінка)",
      thrEnabled: "активний",
      thrAdd: "Додати рядок",
      thrSave: "Зберегти пороги",
      thrSaved: "Пороги збережено",
      thrEmpty: "Пороги ще не визначені — без активних порогів автопілот нічого не запечатує і повідомляє про це як про блокування.",
      capability: "Здатність",
      modSignature: "Сигнатура",
      removeRow: "Прибрати",
      budgetsTitle: "Денні бюджети",
      budgetsSubtitle: "Витрати проти межі за сферою та днем — бюджети обмежують виклики вчителя та embedding.",
      budgetScope: "Сфера",
      budgetDay: "День",
      budgetSpent: "Витрачено",
      budgetCap: "Межа",
      budgetsEmpty: "Бюджети не повідомлені.",
      eventsTitle: "Події",
      eventsSubtitle: "Що автопілот востаннє зробив або повідомив, найновіше спершу.",
      eventsEmpty: "Подій ще немає.",
      storageTitle: "Хмарне сховище",
      storageSubtitle: "З'єднання з Block Storage та ініціалізація структури тек — повторюване без побічних ефектів.",
      connect: "Підключити Block Storage",
      backendLabel: "Backend холодного сховища",
      backendBlockStorage: "Block Storage",
      backendLocal: "Локальне сховище",
      connectedLabel: "З'єднання",
      connectedYes: "підключено",
      connectedNo: "не підключено",
      accountLabel: "Обліковий запис",
      signinValidUntil: "Вхід дійсний до",
      oauthClientLabel: "Клієнт OAuth",
      clientConfigured: "налаштовано",
      clientNotConfigured: "не налаштовано",
      bootstrapRun: "Ініціалізувати структуру",
      bootstrapDone: "Ініціалізацію виконано",
      bootstrapReportTitle: "Останній запуск",
      bootstrapNoRun: "У цій сесії bootstrap ще не виконувався.",
      bootstrapLine: "Створені теки: {folders} · файлів у холодному сховищі: {files} · повтор без змін: {idempotent}",
      treeTitle: "Дерево тек",
      treeSubtitle: "Дерево — це версіонована специфікація: тут ви визначаєте теки, автопілот може лише доповнювати. Захищені теки рушія та непорожні теки рушій відхиляє з обґрунтуванням. У Block Storage видаляють лише за сталими правилами, наприклад старіші копії checkpoint (дві найновіші лишаються); під час повного завантаження видалення й перезаписи чекають, доки воно не завершиться.",
      treeActiveVersion: "Активна версія v{version}",
      treePath: "Шлях",
      treePurpose: "Призначення",
      treeCreatedBy: "Створено ким",
      treeShards: "Шарди",
      treeBytes: "Розмір",
      treeActions: "Дії",
      treeRetire: "Вивести з ужитку",
      treeRetired: "Теку виведено з ужитку",
      treeAddFolder: "Додати теку",
      treeFolderAdded: "Теку створено",
      treeVersionsTitle: "Версії",
      treeEmpty: "Теки ще не визначені.",
      treePlanned: "Заплановано — специфікація дерева v{version}",
      treeFiles: "Файли",
      treeSizesMeasured: "Розміри виміряно {measured}; теки, яких каталог не веде, востаннє пораховано в Block Storage {walked}. 1 GB = 10⁹ байтів.",
      treeSizesNoWalk: "Розміри виміряно {measured}; теки, яких каталог не веде, ще не пораховано. 1 GB = 10⁹ байтів.",
      treeExpand: "Показати підтеки ({count})",
      treeCollapse: "Сховати підтеки",
      treeShowMore: "Показати ще теки ({count})",
      treeSourceCatalog: "З каталогу: враховано об'єкти, які справді лежать у Block Storage",
      treeSourceWalk: "Пораховано під час обходу Block Storage",
      bsUsageTitle: "Місце в Block Storage",
      bsUsageSubtitle: "Зайняте місце, ліміт і вільне місце облікового запису Block Storage та частка data lake в ньому; значення не старші за десять хвилин. 1 GB = 10⁹ байтів.",
      bsUsed: "Зайнято",
      bsLimit: "Ліміт",
      bsFree: "Вільно",
      bsNoLimit: "без фіксованого ліміту",
      bsTrash: "У кошику",
      bsLake: "З них data lake",
      bsLakeLine: "{size}, файлів: {files} · {share} зайнятого місця",
      bsMeasuredAt: "Виміряно",
      bsNotConnected: "Block Storage не під'єднано; місце з'явиться, щойно буде з'єднання.",
      bsBarLake: "Data lake",
      bsBarOther: "Решта облікового запису",
      bsDlTitle: "Повне завантаження",
      bsDlSubtitle: "Завантажує весь Block Storage файл за файлом у ту саму структуру тек, без архіву. Поки воно триває, діє режим захисту: видалення й перезаписи врахованих файлів чекають, доки воно не завершиться; нові файли далі записуються й не входять до цього завантаження. Тренування, що триває, ніколи не затримується.",
      bsDlButton: "Завантажити весь Block Storage",
      bsDlFolderHint: "Ви один раз обираєте цільову теку; підтеки створюються там. Уже повні файли пропускаються, перервані продовжуються з їхньої довжини.",
      bsDlScriptHint: "Цей браузер не може записувати теки. Ви отримаєте скрипт завантаження, який створює ту саму структуру тек і завантажує кожен файл із можливістю продовження.",
      bsDlWindowsNames: "Символи, яких Windows не дозволяє в назвах (наприклад «>»), записуються в цільовій теці як %-код, наприклад %3E.",
      bsDlActiveNote: "Завантаження триває з {time}. Кнопка вгорі продовжує його в цьому браузері; повні файли пропускаються.",
      bsDlBuilding: "Список файлів створюється: поки що файлів: {files}, {size}.",
      bsDlManifest: "Список файлів завантажується: {done} з {total} записів.",
      bsDlFolder: "Цільова тека",
      bsDlFiles: "Файли",
      bsDlData: "Дані",
      bsDlOf: "{done} з {total}",
      bsDlRate: "Швидкість",
      bsDlEta: "Залишилося часу",
      bsDlEtaUnknown: "обчислюється",
      bsDlCurrent: "Зараз завантажується",
      bsDlSkipped: "Уже повні, пропущено: {count}",
      bsDlFailed: "Невдалі файли: {count}",
      bsDlPausedNote: "Призупинено. Після продовження розпочаті файли вантажаться далі з їхньої довжини; режим захисту лишається, поки ця сторінка відкрита.",
      bsDlPause: "Призупинити",
      bsDlContinue: "Продовжити",
      bsDlRetryFailed: "Завантажити невдалі ще раз",
      bsDlFinish: "Завершити",
      bsDlStop: "Зупинити",
      bsDlStateBuilding: "список файлів готується",
      bsDlStateRunning: "завантажує",
      bsDlStatePaused: "призупинено",
      bsDlStateIncomplete: "неповне",
      bsDlStateScript: "скрипт готовий",
      bsDlStateFinished: "завершено",
      bsDlStateStopped: "припинено",
      bsDlStateActive: "активне",
      bsDlFinished: "Усі файли ({files}, {size}) лежать у цільовій теці; завантаження завершено.",
      bsDlFinishedNote: "Завантаження завершено; відкладені видалення й перезаписи виконуються зараз.",
      bsDlStopped: "Завантаження зупинено; відкладені видалення й перезаписи виконуються зараз. Уже завантажені файли лишаються.",
      bsDlEnded: "Сервер завершив завантаження, наприклад після тридцяти хвилин без ознак життя. Нове натискання запускає його знову; повні файли пропускаються.",
      bsDlSession: "Сеанс входу закінчився. Увійдіть знову; після цього кнопка вгорі продовжить завантаження.",
      bsDlDiskFull: "У цільовій теці закінчилося місце. Звільніть місце, а потім продовжте.",
      bsDlPickFailed: "Не вдалося відкрити цільову теку.",
      bsDlScriptPosix: "Скрипт для Linux і macOS",
      bsDlScriptWindows: "Скрипт для Windows",
      bsDlScriptRun: "Збережіть скрипт у цільовій теці й запустіть його там: у Windows подвійним клацанням файлу .cmd або з командного рядка, у Linux і macOS у терміналі командою «sh <файл>».",
      bsDlScriptKeyValid: "Ключ у скрипті дійсний до {time}, лише для цього завантаження і лише для читання.",
      bsDlScriptHeartbeat: "Поки ця сторінка відкрита, вона повідомляє серверу, що завантаження ще триває. Коли скрипт закінчить, натисніть «Завершити».",
      bsDlProtection: "Режим захисту",
      bsDlProtectionState: "Стан",
      bsDlProtectionOn: "активний з {time}",
      bsDlProtectionOff: "неактивний",
      bsDlScope: "Обсяг завантаження",
      bsDlScopeValue: "файлів: {files}, {size}",
      bsDlDeferredDeletes: "Відкладені видалення",
      bsDlDeferredOverwrites: "Відкладені перезаписи",
      bsDlAddedSince: "Додано від початку",
      bsDlLastActivity: "Остання ознака життя",
      acqTitle: "Джерела даних",
      acqSubtitle: "Куровані джерела з відкритою ліцензією: для кожного — ліцензія, оцінка захисту даних, мова, модальність, байтова ціль і виміряний поступ. Вимкнені джерела називають свою причину, а не зникають мовчки.",
      acqGdprNote: "Принцип GDPR: навчальні дані допускаються лише з джерел із відкритою ліцензією та задокументованою оцінкою захисту даних; дані з вхідних проходять PII-очищення перед створенням прикладів (лічильник «PII-очищено» це показує).",
      acqSource: "Джерело",
      acqModality: "Модальність · мова",
      acqLicense: "Ліцензія",
      acqProtection: "Захист даних",
      acqProgress: "Поступ",
      acqDocs: "{count} файлів/об'єктів отримано",
      acqTargetReached: "ціль досягнуто",
      acqExhausted: "джерело вичерпано (список більше нічого не віддає)",
      acqEnabledPill: "активне",
      acqWaitingBuffer: "очікує: буфер заповнений, вивантаження надолужує",
      acqDisabledPill: "вимкнене",
      acqEnable: "Увімкнути",
      acqDisable: "Вимкнути",
      acqEnabledMsg: "Джерело увімкнено",
      acqDisabledMsg: "Джерело вимкнено",
      acqTargetLabel: "Ціль (ГБ)",
      acqSetTarget: "Зберегти ціль",
      acqTargetSaved: "Ціль збережено",
      acqEmpty: "Джерела ще не зареєстровані.",
      balanceTitle: "Мовний баланс німецька/англійська",
      balanceSubtitle: "Завантажені байти за модальністю та мовою — німецька для стартових джерел не повинна відставати від англійської.",
      balanceEmpty: "Вимірів ще немає.",
      modText: "Текст",
      modAudio: "Аудіо",
      modImage: "Зображення",
      modVideo: "Відео",
      prepTitle: "Попередня обробка",
      prepSubtitle: "Пораховані етапи конвеєра від зареєстрованого сирого документа до навчального прикладу — кожне число з каталогу; помилки та непідтримуване названо.",
      prepRegistered: "зареєстровано",
      prepScrubbed: "PII-очищено",
      prepChunked: "розбито",
      prepEmbedded: "вбудовано",
      prepExtracted: "видобуто",
      prepLinked: "пов'язано",
      prepSamples: "приклади",
      prepByLang: "За мовами",
      prepUnsupported: "Не підтримується",
      prepAwaiting: "Очікує на етап",
      prepFailures: "Помилки",
      inboxTitle: "Вхідні сирі дані",
      assetWhat: "Вміст",
      assetFromSource: "з джерела {source}",
      assetFromUpload: "завантажено вручну",
      mediaParquet: "Табличні дані (Parquet)",
      treeShardsHint: "Шарди — це Parquet-пакети даних каталогу: кожен рядок є пакетом із походженням, мовою та призначенням — колонка «призначення» каже, що лежить у теці.",
      mediaWords: {
        text: "Текст",
        audio: "Аудіо",
        video: "Відео",
        image: "Зображення",
        application: "Файл",
      },
      inboxSubtitle: "Передати власні сирі дані в lake: завантажити тут або покласти безпосередньо в хмарну теку raw/inbox/. Звірка реєструє кожен файл; «Обробити зараз» запускає той самий шлях, яким автопілот іде самостійно.",
      uploadButton: "Завантажити файл",
      uploadHint: "До 512 МБ на файл. Завантажене потрапляє в холодне сховище і під час обробки розбивається, вбудовується та пов'язується у граф знань.",
      uploadTooLarge: "Файл більший за 512 МБ.",
      uploadDone: "Файл прийнято",
      processNow: "Обробити зараз",
      processStarted: "Обробку розпочато",
      reconcileNow: "Звірити хмарну теку",
      reconcileDone: "Звірку виконано",
      unprocessedCount: "{count} необроблено",
      inboxEmpty: "Вхідні порожні.",
      assetName: "Файл",
      assetType: "Тип",
      assetSize: "Розмір",
      assetState: "Стан",
      assetLang: "Мова",
      assetRegistered: "Зареєстровано",
      assetStates: {
        raw_stored: "сирі дані збережено",
        awaiting_stt: "очікує розпізнавання мовлення",
        awaiting_content_fetch: "очікує на вміст за адресою",
        awaiting_image_codec: "очікує кодек зображень",
        awaiting_audio_codec: "очікує аудіокодек",
        awaiting_video_codec: "очікує відеокодек",
        chunked: "розбито та в графі",
        processed: "оброблено",
        registered: "зареєстровано",
        queued: "очікує",
        processing: "в обробці",
        ingested: "прийнято",
        linked: "пов'язано",
        unsupported: "не підтримується",
        failed: "невдало",
      },
      graphTitle: "Граф знань",
      graphSubtitle: "Пов'язаний сирий корпус: вузли та ребра, пораховані з каталогу — з цих зв'язків постають навчальні приклади.",
      graphEmbedded: "Вбудовані вузли",
      graphModel: "Модель embedding",
      graphClusters: "Кластери",
      graphAssetsLinked: "Пов'язані сирі дані",
      graphLastLink: "Останнє пов'язування",
      graphNodesTitle: "Вузли за видом",
      graphEdgesTitle: "Ребра за видом",
      graphEmpty: "Граф ще порожній — він постає з першим обробленим файлом.",
      kindCol: "Вид",
      countCol: "Кількість",
      neighborsTitle: "Сусіди вузла",
      nodeIdLabel: "ID вузла",
      neighborsRun: "Отримати сусідів",
      neighborsEmpty: "Сусідів не знайдено.",
      nodeCol: "Вузол",
      edgeKindCol: "Ребро",
      weightCol: "Вага",
      gapTitle: "Матриця покриття та прогалин",
      gapSubtitle: "Виміряний фонд проти налаштованих цілей змішування за здатністю, сигнатурою та рівнем — SQL-подання над каталогом, ніколи не зашите в код.",
      tier: "Рівень",
      gapHave: "Є",
      gapTarget: "Ціль",
      gapWeight: "Вага",
      gapPriority: "Пріоритет",
      targetsTitle: "Визначити цілі змішування",
      targetsSubtitle: "Цілі несуть автора й час; без цілей матриця чесно показує порожній стан.",
      addTargetRow: "Додати рядок",
      saveTargets: "Зберегти цілі",
      targetsSaved: "Цілі збережено",
      statusCol: "Статус",
      tdvTitle: "Запечатаний стан даних",
      tdvSubtitle: "Стан даних незмінний і складається із запечатаних шардів; новий замінює попередній.",
      createTdv: "Створити чернетку TDV",
      tdvCreated: "Чернетку TDV створено",
      tdvId: "TDV",
      tdvName: "Назва",
      tdvMembers: "Складники",
      tdvCreatedAt: "Створено",
      tdvSealedAt: "Запечатано",
      tdvStatusDraft: "чернетка",
      tdvStatusSealed: "запечатано",
      sealTdv: "Запечатати",
      tdvSealed: "TDV запечатано",
      tdvEmpty: "Ще немає Train Data Version — вона складається із запечатаних шардів.",
      compatTitle: "Перевірка сумісності архітектури та даних",
      compatSubtitle: "Правила R1–R12 над двома машиночитаними документами; панель показує збережений звіт рушія і не обчислює власного вердикту.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "не ALL-GREEN",
      compatRun: "Виконати перевірку",
      compatChecked: "Перевірку виконано",
      compatSelectTdv: "Оберіть TDV у списку вище, щоб побачити її звіт.",
      compatNoReport: "Для цієї TDV ще немає збереженого звіту про сумісність.",
      compatDraftNote: "Інтерфейс даних архітектури — чернетка; артефакти токенізатора та кодеків ще не існують. Перевірка стане чинною з першим релізом токенізатора та першою запечатаною TDV.",
      compatRule: "Правило",
      compatTitleCol: "Назва",
      compatKind: "Вид",
      compatEvidence: "Порівняні значення (докази)",
      kindHard: "жорстке",
      kindWarn: "попередження",
      reportsTitle: "Збережені звіти",
      reportsEmpty: "Ще немає збережених звітів про сумісність.",
      phaseLabel: "Фаза навчання",
      phaseA: "Фаза A — готовність та еволюція",
      phaseB: "Фаза B — навчання триває, архітектуру заморожено",
      checklistTitle: "Готовність до навчання (контрольний список фази A)",
      checklistSubtitle: "Умови обчислюються наживо; старт залишається заблокованим, доки кожен пункт не стане зеленим, і кожен невиконаний пункт названо.",
      checklistReady: "готово",
      checklistUnmet: "невиконано пунктів: {count}",
      checklistUnavailable: "Контрольний список недоступний.",
      itemSatisfied: "виконано",
      itemUnsatisfied: "не виконано",
      startTraining: "Запустити фазу B",
      strandTitle: 'Навчальна гілка',
      strandSubtitle: 'Яка гілка моделі навчається, щойно виконані всі передумови; невибрана гілка далі готує дані, але ніколи не стартує.',
      strandSelectedBadge: 'вибрана',
      strandExplain: 'Автопілот навчає {selected}. {other} далі збирає й готує, але не стартує, поки не вибрана.',
      strandSwitched: 'Вибір збережено.',
      strandSwitchFailed: 'Перемкнути не вдалося.',
      strandUnavailable: 'Цей бекенд ще не надає гілок; перемикач з\'явиться після наступного розгортання ядра.',
      trainingStarted: "Фазу B запущено",
      startBlocked: "Старт заблоковано — не виконано: {items}",
      selectedTdvLabel: "Вибраний стан даних",
      computedAt: "Обчислено",
      runsTitle: "Навчальні запуски",
      runsSubtitle: "Лише реальні запуски з каталогу; симульованого процесу навчання не існує.",
      runId: "Запуск",
      archVersion: "Архітектура",
      presetCol: "Пресет",
      seqLenCol: "Довжина послідовності",
      stepCol: "Крок",
      lossCol: "Loss",
      runStarted: "Розпочато",
      runFinished: "Завершено",
      runsEmpty: "Ще немає навчальних запусків.",
      abortRun: "Перервати",
      confirmAbort: "Перервати цей навчальний запуск?",
      runAborted: "Переривання запитано",
      benchLink: "Бенчмарк",
      benchTitle: "Звіти бенчмарків",
      benchSubtitle: "Заморожена, версіонована сюїта запускається автоматично після кожного навчання; кожен звіт лежить у lake і показаний тут.",
      benchEmpty: "Звіту бенчмарку ще немає.",
      suiteVersion: "Сюїта",
      benchOpen: "Відкрити",
      benchReportFor: "Звіт бенчмарку для запуску {run}",
      benchNoMarkdown: "Цей звіт не містить відрендереного документа; сирі результати нижче.",
      exportsTitle: "Експорти",
      exportsSubtitle: "Завантаження існують виключно для експортів завершених реальних навчальних запусків.",
      exportId: "Експорт",
      exportSize: "Розмір",
      exportSha: "SHA-256",
      download: "Завантажити",
      exportsEmpty: "Ще немає експорту — він постає лише із завершеного реального навчального запуску.",
      hfTitle: "Публікації на HuggingFace",
      hfSubtitle: "Кожне завантаження є приватним; видимість перевіряється через API після завантаження. Неприватний результат — це стан помилки, що зупиняє цикл.",
      hfEmpty: "Публікацій ще немає.",
      hfRepo: "Репозиторій",
      hfState: "Стан",
      hfVisibility: "Видимість",
      hfPrivateVerified: "приватно — перевірено",
      hfUnverified: "ще не перевірено",
      hfVerifiedAt: "Перевірено",
      connectTitle: "Підключити Block Storage",
      connectSubtitle: "Вхід через вікно входу постачальника сховища; сховище з\'єднується з обліковим записом, який підтвердить.",
      webConnectStart: "Під\'єднати через постачальника сховища",
      webConnectWaiting: "Очікування підтвердження у вікні входу постачальника сховища…",
      webConnectHint: "Після підтвердження сховище під\'єднається автоматично; діалог оновиться сам.",
      publicIdentity: "Публічна ідентичність застосунку (rclone, спільна квота)",
      publicIdentityNote: "Вікно входу постачальника сховища показує «rclone» як застосунок, що запитує доступ — це публічно спільна ідентичність; власний client ID (GDRIVE_OAUTH_CLIENT_ID) будь-коли її замінює.",
      manualHint: "Після підтвердження браузер покаже недоступну сторінку localhost. Скопіюйте значення параметра code= з адресного рядка та вставте сюди (можна вставити й усю адресу).",
      manualCodeLabel: "Код авторизації",
      manualSubmit: "Застосувати код",
      deviceInstead: "Використати код пристрою",
      licenseAcceptLink: "Підтвердити ліцензію на Hugging Face",
      deviceFlowTitle: "Підключити Block Storage (device flow)",
      deviceFlowSubtitle: "Рушій запускає потік входу постачальника для пристроїв; підтвердження відбувається на другому пристрої та опитується з обмеженими інтервалами.",
      deviceFlowStart: "Запустити потік входу",
      deviceFlowCode: "Код пристрою",
      deviceFlowOpenUrl: "Відкрити сторінку підтвердження",
      deviceFlowWaiting: "Очікування підтвердження — опитування з інтервалом, який приписує постачальник.",
      deviceFlowAuthorized: "Підключено",
      deviceFlowExpired: "Код пристрою прострочено — запустіть потік входу знову.",
      readinessTitle: "Готовність до тренування",
      readinessSubtitle: "Виміряний шлях до першого тренувального запуску, етап за етапом.",
      readinessCounter: "{green} з {total} виконано",
      readinessReady: "Готово до тренування",
      unblockLabel: "Наступний крок",
      readinessUnavailable: "Огляд готовності ще не розгорнуто в бекенді. Щойно кінцева точка запрацює, тут з'явиться виміряний стан.",
      stageStates: {
        ok: "виконано",
        active: "виконується",
        waiting: "очікує",
        blocked: "заблоковано",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'недоступно',
      equilibrium: 'Досягнуто оптимального робочого стану: на всі запити надано відповіді, усі передачі завдань опрацьовано, дублювання усунено.',
      standby: 'очікування',
      defTitle: 'Операційна Координація Команди та Метрики Ефективності',
      defSubtitle: 'Вимірювання якості операційної комунікації та передачі завдань між усіма ШІ-ролями: фокус на верифікованих результатах замість непродуктивної активності.',
      defPlayers: 'Залучені Ролі та Системи',
      defPlayersText: 'Десять спеціалізованих ШІ-ролей із власними ботами Webex та керівники-люди, які визначають завдання й управлінські директиви.',
      defStrategies: 'Принципи Комунікації та Роботи',
      defStrategiesText: 'Пряма відповідь на запити, однозначна й повна передача завдань, уникнення дублювання та послідовне завершення відкритих робочих пакетів.',
      defPayoff: 'Чистий Операційний Внесок (Корисність)',
      defPayoffText: 'Завершені робочі пакети, успішно опрацьовані передачі завдань і надані відповіді — за вирахуванням операційних втрат (дублювання, неопрацьовані передачі, запити без відповіді).',
      defEquilibrium: 'Оптимальний Робочий Стан (Координаційна Рівновага)',
      defEquilibriumText: 'Цільовий стан співпраці: кожен запит отримує своєчасну відповідь, кожна передача завдання приймається в роботу, жодна інформація не дублюється і жоден робочий пакет не зависає.',
      playersTitle: 'Огляд Ефективності за Ролями (Позиції)',
      playersSubtitle: 'Операційні показники комунікації та виконання за ролями: фахові внески й передачі завдань (останні 7 днів), а також наради й завершені пакети (останні 30 днів).',
      playersHint: 'Чиста корисність = 3 × завершені робочі пакети + опрацьовані передачі − операційні втрати (неопрацьовані передачі враховуються двічі). Від’ємне значення вказує на потребу в координації.',
      player: 'Роль / Позиція',
      contributions: 'Дописи',
      meetingTurns: 'Зустрічі',
      handovers: 'Передачі',
      consumedShort: 'опрацьовані',
      refusedShort: 'відхилені',
      delivery: 'Доставка',
      pausedTurns: 'Призупинені ходи',
      pausedTurnsHint: 'Ходи, збережені у власній поштовій скриньці колеги, бо моделі не змогли їх обслужити одразу. Це не передачі.',
      closedOpen: 'закриті / відкриті',
      noise: 'Операційні втрати',
      utility: 'Чистий внесок',
      meetingsLine: '{held} зустрічей, {turns} виступів, {u} звернень без відповіді (30 днів).',
      interactionsTitle: 'Передача Завдань між Ролями (Матриця Handover)',
      interactionsSubtitle: 'Спрямовані передачі завдань між поштовими скриньками (останні 7 днів): кількість, час доставки та опрацьовані й відхилені передачі.',
      interactionsHint: 'Передача завдання вважається завершеною лише після опрацювання отримувачем; відхилені або неопрацьовані передачі фіксуються як процесні відхилення.',
      interactionsEmpty: 'У цьому вікні передач немає.',
      from: 'Від',
      to: 'Кому',
      messages: 'Повідомлення',
      consumed: 'опрацьовані',
      refused: 'відхилені',
      deviationsTitle: 'Процесні Відхилення та Активні Вузькі Місця',
      deviationsSubtitle: 'Поточні збої координації: запити без відповіді, неопрацьовані передачі завдань, дублювання повідомлень або заблоковані робочі пакети.',
      dev_unanswered_question: 'Запит без відповіді (перевищено час очікування)',
      dev_dead_air: 'Передача завдання без зворотного зв’язку',
      dev_repetition: 'Повторення на зустрічі',
      dev_meeting_unanswered: 'Пряме звернення без відповіді',
      dev_work_blocked: 'Робота заблокована',
      dev_handover_hop_budget_reached: 'Перевищено ліміт кроків передачі',
      dev_commitment_unkept: 'Зобов’язання спринту не виконано',
      devWithheld: 'притримано',
      devRepetition: 'повторення',
      devDeadAir: 'неопрацьована передача',
      devMeetingUnanswered: 'без відповіді',
      effectiveThresholdCol: 'Еф. поріг',
      excessHopsLabel: 'Надлишкові кроки передач',
      timeTitle: 'Тривалість Циклів і Порівняння Продуктивності (ШІ проти ручного виконання)',
      timeSubtitle: 'Фактичний час виконання інженерних завдань ШІ порівняно з оціненими трудовитратами людини.',
      timeHint: 'Базові розрахункові значення для оцінки трудовитрат; налаштовуються керівництвом.',
      avgCycle: 'Сер. цикл ШІ',
      fromTasks: 'з {n} задач',
      speedup: 'Прискорення',
      speedupHint: 'прийнято {h} людино-годин на одиницю',
      humanDelivered: 'Доставлені людино-дні',
      humanDays: 'людино-днів',
      forecast: 'Прогноз відкритої роботи: {d} людино-днів',
      sizes: 'Розміри',
      sizeSmall: 'малі',
      sizeMedium: 'середні',
      sizeLarge: 'великі',
      scrumTitle: 'Скрам',
      scrumSubtitle: 'Спринт, сторі-поінти та velocity, із власних даних компанії',
      sprintLabel: 'Спринт {n}',
      ends: 'завершується',
      committedPts: 'Взяті поінти',
      deliveredPts: 'Доставлені поінти',
      remainingPts: 'Залишок поінтів',
      burndownTitle: 'Burndown (залишок поінтів на день)',
      velocityTitle: 'Velocity закритих спринтів',
      predictability: 'передбачуваність',
      forecastLine: 'Ковзна velocity {v} поінтів за спринт · беклог {b} поінтів ≈ {s} спринтів',
      noSprint: 'Спринт не триває; наступне планування відкриє новий.',
      noItems: 'Ще нічого не взято; спринт бере те, що приносять люди.',
      colItem: 'Завдання',
      colOwner: 'Відповідальний',
      colPoints: 'Поінти',
      colState: 'Стан',
      itemDone: 'доставлено',
      itemOpen: 'відкрито',
      unestimated: 'без оцінки',
      addedBy: 'додано {who}',
      setGoal: 'Мета спринту',
      sprintDaysLabel: 'Тривалість спринту (дні)',
      save: 'Зберегти',
      endSprint: 'Завершити спринт зараз',
      confirmEndSprint: 'Завершити спринт зараз? Огляд, ретроспектива та наступне планування відбудуться одразу.',
      planNow: 'Провести перше планування зараз',
      confirmPlanNow: 'Провести планування спринту зараз? Воно відкриє перший спринт у pAIoneer-scrum.',
      sprintPointsCol: 'Поінти спринту',
      ceremonySpaceLabel: 'Простір церемоній',
      scrumOfScrums: 'Провести Scrum of Scrums',
      confirmScrumOfScrums: 'Провести Scrum of Scrums між усіма бізнес-підрозділами зараз?',
      lastScrumOfScrumsTitle: 'Останній Scrum of Scrums',
      escalatedImpedimentsTitle: 'Ескальовані перешкоди',
      unitBreakdownTitle: 'Розподіл спринту за бізнес-підрозділами',
      colUnit: 'Бізнес-підрозділ',
      colWip: 'Відкрита робота',
      colImpediments: 'Перешкоди',
    },
    nav: {
      groups: {
        gametheory: 'Координація команди та Scrum',
        demos: 'Живі перегляди',
        sovereign: 'Суверенна LLM',
        today: 'Оперативний огляд і Центр керування',
        organisation: 'Організація',
        work: 'Робота',
        communication: 'Комунікація',
        memory: 'Пам\'ять',
        platform: 'Платформа',
        products: 'Продукти',
        identity: 'Ідентичність',
      },
      pages: {
        gametheory: 'Координація команди та Scrum',
        demos: 'Живі перегляди',
        llm: 'Архітектура LLM — наукова стаття',
        training: 'Data Lake та Навчання ШІ-моделі',
        today: 'Оперативний огляд і Центр керування',
        work: 'Робочі пакети та проєкти',
        coding: 'Завдання з програмування',
        gitlab: 'GitLab та Збірки образів',
        agents: 'Агенти та проєкти агентів',
        research: 'Дослідження',
        webex: 'Простори Webex',
        mailboxes: 'Поштові скриньки',
        conversations: 'Дзвінки та розмови',
        meetings: 'Наради',
        engines: 'ШІ-рушії та GPU',
        usage: 'Споживання та бюджети',
        workloads: 'Контейнерні сервіси',
        orchestrator: 'Оркестратор MCP Veridion',
      },
      sections: {
        demos: {
          previews: 'Живі перегляди',
        },
        llm: {
          paper: 'Стаття',
          monitoring: 'Моніторинг',
        },
        training: {
          autopilot: "Автопілот",
          storage: "Хмарне сховище та дерево тек",
          acquisition: "Збирання даних та попередня обробка",
          data: "Дані та граф знань",
          training: "Навчання та публікація",
        },
        platform: {
          nodes: 'Вузли кластера',
          events: 'Події',
        },
        smtm: {
          runtime: 'Керування середовищем виконання',
          prediction: 'Керування прогнозами',
          status: 'Стан даних',
          reporting: 'Сигнали',
          training: 'Моделі',
          console: 'Консоль навчання',
        },
        agentic: {
          overview: 'Огляд',
          tools: 'Інструменти',
          mcp: 'MCP-сервери',
          activity: 'Активність',
        },
        'company-memory': {
          content: 'Вміст',
          search: 'Пошук і зведення',
          facts: 'Факти',
          entity: 'Сутності',
          remember: 'Записати',
          audit: 'Журнал аудиту',
          console: 'Консоль запитів',
          stores: 'Сховища',
          graph: 'Граф знань',
          day: 'День',
            bubbles: 'Домени знань підрозділів і Дослідження'
        },
        organisation: {
          chart: 'Організаційна схема',
          colleagues: 'ШІ-колеги та поштові скриньки',
          voices: 'Голоси',
          people: 'Люди та простори',
          approvals: 'Погодження та розклади',
          edit: 'Редагування організації',
        },
        work: {
          items: 'Робочі пакети',
          projects: 'Проєкти в розробці',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Збірки образів',
        },
        agents: {
          agents: 'Агенти',
          designs: 'Проєкти агентів',
          definitions: 'Визначення',
        },
        usage: {
          identities: 'За ідентичністю',
          budgets: 'Бюджети токенів',
          company: 'Інстанція компанії',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Середовище виконання',
          mcp: 'Сервери MCP',
          tools: 'Інструменти',
          activity: 'Активність',
        },
      },
      attentionTitle: 'Потрібні дії',
      attentionSubtitle: 'Стани з усіх розділів, що потребують втручання. Клік відкриває розділ.',
      attentionNone: 'Дії не потрібні.',
      stateTitle: 'Робочий стан',
      none: 'немає',
      readyOf: '{ready} з {total} готові',
      connectedOf: '{connected} з {total} підключені',
      registeredOf: '{registered} з {total} зареєстровані',
      showMore: 'Показати більше',
      shownOf: '{shown} з {total}',
      expand: 'Розгорнути',
      collapse: 'Згорнути',
      service: 'Сервіс',
      serviceLinks: 'Посилання',
      controlsTitle: 'Керування Veridion Core',
      confirmRemove: 'Видалити {what}?',
      companyIdentitiesTitle: 'Ідентичності шлюзу інстанції компанії',
      companyIdentitiesSubtitle: 'Токени оркестратора та Veridion Core у поточному вікні шлюзу, кожна ідентичність зі своїм бюджетом.',
      conversationsTitle: 'Розмови з панелі',
      conversationsSubtitle: 'Для кожного ШІ-колеги письмові розмови з панелі; написати та зателефонувати відкривають діалог над сторінкою.',
      conversationCount: 'Повідомлення',
      conversationLastWritten: 'Востаннє написано',
      conversationLastAnswered: 'Востаннє відповідено',
      exchangesTitle: 'Повідомлення та відповіді',
      exchangesSubtitle: 'Кожне повідомлення з панелі з відповіддю ШІ-колеги, найновіші спочатку.',
      conversationMessage: 'Повідомлення',
      conversationAnswer: 'Відповідь',
      today: {
        wordTitle: 'Чинна управлінська директива',
        wordNone: 'Наразі немає відкритої управлінської директиви.',
        sinceTitle: 'Події з моменту останнього перегляду',
        sinceState: 'від {time}',
        workTitle: 'Активні завдання та Відповідальні',
        workNone: 'Жоден робочий пакет не в роботі.',
        nextMeeting: 'Наступна зустріч',
        lastMeeting: 'Остання зустріч',
      },
      work: {
        title: 'Робочі пакети',
        subtitle: 'Кожен відкритий робочий пакет з пам\'яті компанії з відповідальним, станом, пріоритетом, терміном і результатами його сценаріїв; заголовок відкриває його у графі.',
        item: 'Робочий пакет',
        kind: 'Вид',
        owner: 'Відповідальний',
        status: 'Стан',
        priority: 'Пріоритет',
        due: 'Термін',
        scenarios: 'Сценарії',
        updated: 'Оновлено',
        none: 'Немає відкритих робочих пакетів.',
        all: 'Усі відповідальні',
      },
      meetings: {
        subtitle: 'Зустрічі ШІ-колег, як їх фіксує Veridion Core: часовий слот, підсумок і зобов\'язання, що стали роботою.',
        slot: 'Слот',
        kind: 'Вид',
        started: 'Розпочато',
        ended: 'Завершено',
        summary: 'Підсумок',
        commitments: 'Зобов\'язання',
        hold: 'Провести зустріч зараз',
        held: 'Зустріч скликано.',
        notHeld: 'Зустріч триває або відбулася протягом останніх пів години.',
        holdFailed: 'Не вдалося скликати зустріч',
        none: 'Ще не зафіксовано жодної зустрічі.',
      },
      research: {
        title: 'Дослідження',
        subtitle: 'Дослідження ШІ-колег із хронології компанії, найновіші спочатку.',
      },
      attention: {
        toneError: 'Збій',
        toneWarning: 'Примітка',
        state: {
          platform: '{ready} з {workloads} робочих навантажень готові, {nodes} з {total} вузлів готові, {restarts} перезапусків.',
          gateway: '{state}; {models} моделей маршрутизовано, {backends} з {total} обслуговуючих бекендів готові.',
          engine: '{engine}: {running} виконуються, {waiting} очікують',
          usage: '{tokens} токенів у {identities} ідентичностях у вікні {window}.',
          smtm: 'Прогнозні ворота {gate}, перебудова {rebuild}; {online} з {models} моделей онлайн, {failed} невдалих.',
          smtmSignals: '{open} відкритих сигналів, {resolved} вирішено, {failed} доставок невдалі.',
          smtmVeridion: '{connected} з {servers} серверів MCP підключені.',
          company: 'Оркестратор {status}; {ready} з {workloads} робочих навантажень готові; Veridion Core {core}; {agents} агентів працюють, {waiting} очікують.',
          companyWebex: '{registered} з {bots} вебхуків ботів зареєстровані.',
          approvals: '{approvals} відкритих погоджень; {tasks} завдань з кодування чекають на людину або перегляд.',
          sessions: '{users} користувачів увійшли, {sessions} сесій, {mfa} підтверджених, {total} облікових записів.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Стан платформи неможливо прочитати.',
        nodeNotReady: 'Вузол {name} не готовий.',
        nodePressure: 'Вузол {name} повідомляє про нестачу: {pressure}.',
        workloadDown: '{name} ({namespace}): готово {ready} з {desired}.',
        gatewayNotProgrammed: 'AI-шлюз не запрограмовано.',
        smtmGateClosed: 'Шлюз прогнозів закрито.',
        smtmRebuild: 'Позначено перебудову.',
        smtmHint: 'Стан даних: {hint}.',
        smtmDeliveryFailed: 'Не вдалося доставити сигналів: {count}.',
        smtmModelsFailed: 'Моделей з помилкою: {count}.',
        mcpUnreachable: 'MCP-сервер {server} екземпляра {instance} недоступний.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} не відповідає.',
        parts: {
          orchestrator: 'оркестратор',
          webex: 'міст Webex',
          knowledge: 'база знань',
          core: 'Veridion Core',
          mcp: 'MCP-сервери',
          usage: 'журнал споживання',
          gateway: 'споживання шлюзу',
        },
        emergencyStop: 'Аварійну зупинку Veridion Core увімкнено.',
        coreMisconfigured: 'Veridion Core бракує налаштувань: {missing}.',
        agentsWaiting: 'Агентів, що чекають на відповідь: {count}.',
        hostedNotRunning: '{agent} не працює.',
        webhookMissing: 'Вебхук {bot} не зареєстровано.',
        readerNotAuthorised: 'Читання просторів компанії не дозволено.',
        approvalOpen: 'Відкрите погодження ({position}): {question}',
        taskWaiting: 'Завдання з кодування чекає на людину: {title}',
        taskReview: 'Merge request готовий до перевірки: {title}',
      },
    },
    ops: {
      showDetails: 'Деталі',
      hideDetails: 'Закрити',
      mcpVersion: 'Версія',
      mcpUrl: 'Адреса',
      mcpProtocol: 'Транспорт і протокол',
      mcpLastRefresh: 'Останній запит',
      mcpError: 'Помилка',
      noTools: 'Інструменти не повідомлено.',
      toolServer: 'Походження',
      toolAccess: 'Доступ',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'читає',
      accessWrites: 'записує',
      accessDestructive: 'змінює дані',
      accessUndeclared: 'не вказано',
      usageTitle: 'Споживання',
      smtmUsageSubtitle: 'Виклики моделей, токени та вартість, повідомлена постачальником, за останні 30 днів.',
      usageByPerson: 'За особою',
      usageByModel: 'За моделлю',
      usageByDay: 'За днем',
      model: 'Модель',
      day: 'День',
      promptTokens: 'Вхідні токени',
      completionTokens: 'Вихідні токени',
      noUsage: 'Споживання не зафіксовано.',
      runtimeTitle: 'Середовище виконання',
      runtimeSubtitle: 'Як оркестратор цього екземпляра звертається до моделей і підключає інструменти.',
      executionMode: 'Виконання',
      providerProtocol: 'Протокол до моделі',
      contextWindow: 'Контекстне вікно',
      requestTimeout: 'Тайм-аут запиту',
      diagnostics: 'Діагностика',
      diagnosticsOn: 'увімкнено',
      diagnosticsOff: 'вимкнено (режим продуктивності)',
      externalServers: 'Підключені MCP-сервери',
      mcpEndpoint: 'Кінцева точка MCP',
      workloadsTitle: 'Робочі навантаження',
      workloadsSubtitle: 'Робочі навантаження в просторі імен paioneer-veridion, як їх повідомляє Kubernetes.',
      botsTitle: 'Боти',
      botsSubtitle: 'Боти організації, кожен зі своїм вебхуком, і служби мосту.',
      botAddress: 'Адреса',
      cardWebhook: 'Вебхук карток',
      webhookState: 'Стан',
      noBots: 'Міст не повідомляє ботів.',
      bridgeServices: {
        knowledgeBase: 'База знань',
        webResearch: 'Пошук в інтернеті',
        osint: 'OSINT',
        anonymizer: 'Анонімізація',
      },
      connected: 'підключено',
      notConnected: 'не підключено',
      activeRooms: 'Активні кімнати',
      allowedRooms: 'Дозволені кімнати',
      surface: 'Поверхня',
      missingSettings: 'Відсутні налаштування',
      none: 'немає',
      instanceToolsTitle: 'Інструменти оркестратора',
      instanceToolsSubtitle: 'Інструменти, які зареєстрував оркестратор екземпляра компанії.',
      openMailbox: 'Скринька',
      positionMailboxHint: 'ШІ-колеги опрацьовують передачі від інших ШІ-колег; доручення ШІ-колезі дають у його просторі Webex.',
      mailboxesTitle: 'Поштові скриньки',
      mailboxesSubtitle: 'Для кожного агента: що чекає в його скриньці, доставлено й прочитано. Клік по рядку фільтрує повідомлення.',
      readAt: 'Прочитано',
      refresh: 'Оновити',
      mailbox: 'Скринька',
      mailboxKind: 'Тип',
      mailboxKinds: {
        position: 'ШІ-колега',
        hosted: 'Розміщений агент',
        graph: 'Агент',
      },
      lastMessage: 'Останнє повідомлення',
      noMailboxes: 'Жодну скриньку не вдалося прочитати.',
      messagesTitle: 'Повідомлення',
      messagesSubtitle: 'Повідомлення, команди та передачі, спочатку найновіші. Клік показує повний текст.',
      allMailboxes: 'Усі скриньки',
      allStates: 'Усі стани',
      time: 'Час',
      from: 'Від',
      to: 'Кому',
      messageKind: 'Тип',
      content: 'Вміст',
      reply: 'Відповідь',
      noMessages: 'Повідомлень немає.',
      messageKinds: {
        message: 'Повідомлення',
        handover: 'Передача',
        command: 'Команда',
        resume: 'Продовження',
        subagent_result: 'Результат субагента',
        review: 'Перевірка',
      },
      buildsTitle: 'Збірки',
      buildsSubtitle: 'Образи, які Veridion Core зібрав для агентів, спочатку найновіші.',
      image: 'Образ',
      started: 'Розпочато',
      finished: 'Завершено',
      noBuilds: 'Збірок немає.',
      coreToolsTitle: 'Інструменти агентів',
      coreToolsSubtitle: 'Інструменти оркестратора, які Veridion Core пропонує своїм агентам.',
      description: 'Опис',
      coreDailyTitle: 'Споживання за днем і моделлю',
      coreDailySubtitle: 'Виклики моделей Veridion Core за останні 30 днів, за агентом і моделлю.',
      coreActivityTitle: 'Активність Veridion Core',
      coreActivitySubtitle: 'Події агентів, ШІ-колег і передач у Veridion Core, спочатку найновіші.',
      event: 'Подія',
      tool: 'Інструмент',
      detail: 'Деталь',
    },
    tabCompanyMemory: 'Пам\'ять компанії',
    llmPaper: {
      subtitle: 'Згенерований науковий опис суверенної архітектури моделі — відображений з paper-документа, який Veridion Core веде для активної специфікації.',
      summaryTitle: 'Що показує ця сторінка',
      summaryBody: 'Veridion Core веде для активної архітектури моделі згенерований науковий документ: назва, анотація, нумеровані розділи, діаграма архітектури, таблиці та література надходять з backend без змін; проєктні значення позначені як такі, і сторінка нічого не вигадує.',
      refresh: 'Оновити',
      exportPdf: 'Експортувати як PDF',
      strandTraining: 'навчається',
      strandSelected: 'вибрано',
      lcTitle: "Імплементація та життєвий цикл",
      lcSelectedTrains: "тренується наступним",
      lcCollectsOnly: "збирає та готує — не стартує",
      lcSpec: "Специфікація",
      lcFrozen: "заморожена",
      lcArtifacts: "Артефакти (токенізатор/кодек)",
      lcReleased: "випущені",
      lcNotReleased: "ще не збудовані",
      lcCodecOpen: "кодек відкритий",
      lcData: "Пороги даних",
      lcThresholdsMet: "виконані",
      lcAreasReached: "план даних: досягнуто {met} з {total} галузей",
      lcNoLake: "озеро даних недоступне",
      lcStage_trainer_image: "Образ тренера",
      lcStage_sealed_tdv: "TDV запечатано",
      lcStage_compat_all_green: "Сумісність ALL-GREEN",
      lcStage_vram_budget: "Бюджет VRAM",
      lcTraining: "Навчання",
      lcAuto: "стартує автоматично після виконання порогів",
      lcBench: "Бенчмарк",
      lcBenchRows: "вимірювань",
      lcNoneYet: "ще немає",
      lcRelease: "Експорт · Hugging Face (приватно) · реєстр",
      lcReleaseRows: "артефактів",
      lcReleaseNote: "після навчання: приватно-перевірене завантаження + запис у реєстрі",
      lcPipeline: "Навчальний конвеєр",
      lcDone: "готово",
      lcActive: "активно",
      lcWaiting: "очікує",
      lcBlocked: "заблоковано",
      lcCapability: "Здатність",
      lcSamples: "Зразки",
      lcByLanguage: "за мовою",
      lcForeign: 'інший напрям',
      lcCorpus: 'Токени корпусу',
      lcCorpusNone: 'ще не токенізовано',
      loading: 'Завантаження …',
      unavailable: 'Paper-документ недоступний.',
      noPaper: 'Ця версія Veridion Core ще не надає paper-документа. Тому сторінка не показує нічого вигаданого.',
      abstract: 'Анотація',
      references: 'Література',
      appendix: 'Додаток',
      figure: 'Рисунок',
      lastUpdated: 'Останнє оновлення',
      empty: 'Немає записів.',
    },
    llmMonitor: {
      summary: "Операційний нагляд за моделлю: стан, дані, GPU, ядра й пропускна здатність, оцінки та події — виміряно з Veridion Core і data lake, нічого вигаданого.",
      archTitle: 'Статус архітектури',
      archSubtitle: "Активна архітектура зі станом інтерфейсу даних і станом заморожування.",
      version: 'Версія',
      codename: 'Кодова назва',
      statusLabel: 'Статус',
      interfaceStatus: 'Інтерфейс даних',
      specSha: 'Хеш специфікації (SHA-256, скорочено)',
      promotedAt: 'Підвищено',
      frozenLabel: 'Заморожено',
      frozenYes: 'Так',
      frozenNo: 'Ні',
      stateWord_active: "активна",
      stateWord_draft: "чернетка",
      stateWord_released: "випущена",
      stateWord_candidate: "кандидат",
      stateWord_retired: "завершена",
      gpuModel: "Відеокарта",
      gpuTotal: "Загальна графічна пам'ять",
      gpuWindow: "Вікно навчання (виміряне)",
      gpuMeasuredAt: "Виміряно",
      gpuSource: "Джерело вимірювання",
      gpuServing: "Обслуговування",
      gpuInferenceTarget: "Ціль інференсу на одній карті",
      vramTitle: 'GPU та бюджет VRAM',
      vramSubtitle: 'Виміряний бюджет VRAM відеокарти, як його веде Veridion Core.',
      vramNone: 'У записі немає бюджету VRAM.',
      gateTitle: 'Гейт просування',
      gateSubtitle: 'Політика, за якою архітектура-кандидат замінює активну, з необхідними метриками та їхніми вагами.',
      metric: 'Метрика',
      weight: 'Вага',
      gateNone: 'Необхідні метрики не задані.',
      candidatesTitle: 'Кандидати',
      candidatesNone: 'Немає архітектур-кандидатів.',
      evidenceTitle: 'Оцінювання',
      evidenceNone: 'Виміряних оцінювань ще немає.',
      benchmark: 'Бенчмарк',
      suite: 'Набір',
      score: 'Результат',
      evaluator: 'Оцінювач',
      date: 'Дата',
      changelogTitle: 'Журнал змін',
      changelogNone: 'В історії ще немає версій архітектури.',
      summaryLabel: 'Підсумок',
      createdAt: 'Створено',
      supersededAt: 'Замінено',
      eventsTitle: 'Події',
      eventsNone: 'Подій не зафіксовано.',
      implTitle: 'Стан реалізації гілки',
      implSubtitle: "Виміряні факти: артефакти інтерфейсу даних, вибір, токен-корпус і векторний індекс; план даних за галузями — у ситуації.",
      implSelected: 'Навчальна гілка',
      implSelectedYes: 'вибрана — навчається наступною',
      implSelectedNo: 'лише готує (ніколи не стартує)',
      implTokenizer: 'Артефакт токенізатора',
      implCodec: 'Артефакт кодека',
      implNotReleased: 'ще не опубліковано',
      implCapability: 'Здатність',
      implSamples: 'Приклади (виміряно/ціль)',
      implNoDatalake: 'Прогрес прикладів наразі неможливо прочитати (інтерфейс озера даних недоступний).',
      implSwitchHint: 'Вибір навчальної гілки перемикається на сторінці навчання.',
      implSituationLink: "Де дані та чого бракує навчанню: ситуація на сторінці навчання",
      kernelTitle: 'Прискорення ядер і пропускна здатність',
      kernelSubtitle: 'Що зонд ядер виміряв на карті: кожне ядро проти свого еталона, бекенд уваги, пропускна здатність обраної специфікації — і план часу, обчислений з виміряних токенів і виміряної пропускної здатності.',
      kernelNone: 'На цій карті ще не запускався зонд ядер; нічого не припускається.',
      kernelName: 'Ядро',
      kernelVerified: 'Доведено',
      kernelYes: 'так',
      kernelNo: 'ні',
      kernelSpeedup: 'Прискорення',
      kernelMaxErr: 'Макс. похибка',
      kernelError: 'Результат',
      kernelAttention: 'Бекенд уваги',
      kernelDocMask: 'Маскування меж документів',
      kernelThroughput: 'Виміряна пропускна здатність (токенів/с)',
      kernelMicroBatch: 'Мікропакет',
      kernelMeasuredAt: 'Виміряно',
      kernelImage: 'Образ тренера (дайджест)',
      kernelRunPath: 'Шлях ядер останнього запуску',
      kernelRunNone: 'Ще немає тренувального запуску з даними про ядра.',
      kernelPlanTitle: 'План часу (арифметика над вимірюваннями)',
      kernelPlanTokens: 'Маса токенів',
      kernelPlanTokensSource: 'Джерело маси токенів',
      kernelPlanDays: 'Прогнозовані дні на один прохід',
      kernelPlanNone: 'Ще не виміряно — без виміряної пропускної здатності або виміряної маси токенів план часу не вигадується.',
      kernelSourceTdv: 'запечатана версія тренувальних даних',
      kernelSourceCorpus: 'корпус на сьогодні (не запечатаний)',
      kernelSourcePlan: "бюджет за статтею",
      implForeign: 'належить іншому напряму',
      implIndex: 'Векторний індекс (звʼязування графа)',
      implIndexNone: 'індекс не повідомлено',
      implIndexDown: 'налаштовано, не відповідає',
      implIndexPoints: 'точок',
      implIndexBackfillDone: 'наповнення завершено',
      implIndexBackfillOpen: 'наповнення триває',
      implIndexLink: 'Індекс і дедуплікація в моніторі озера',
      implCorpus: 'Корпус токенів (сирий текст)',
    },
    software: {
      arch: {
        execTitle: "Суверенна архітектура моделі",
        execSubtitle: "Єдина активна специфікація архітектури з Veridion Core: кожна цифра або підтверджена посиланням на артефакт вимірювання, або позначена backend'ом як проєктна ціль (не виміряно).",
        openDatalake: "Відкрити Data Lake та навчання моделі ШІ",
        unavailableArch: "Дані архітектури недоступні.",
        frozen: "Заморожено — триває навчальний запуск",
        notFrozen: "Допущено (фаза A)",
        version: "Версія",
        codename: "Кодова назва",
        statusLabel: "Статус",
        createdAt: "Створено",
        promotedAt: "Підвищено",
        specSha: "Хеш специфікації (SHA-256)",
        contextWindow: "Контекстне вікно (проєкт, токени)",
        dataInterface: "Інтерфейс даних",
        diStatus: {
          draft: "чернетка",
          complete: "повний",
          missing: "відсутній",
        },
        paramsTitle: "Баланс параметрів",
        trainingVramTitle: "VRAM навчання (заявлено, ГБ)",
        inferenceTitle: "VRAM інференсу (заявлено, ГБ)",
        declaredTotal: "Заявлена сума",
        budgetTitle: "Бюджет VRAM GPU (виміряно)",
        budgetGpu: "GPU",
        budgetTotal: "Загальний VRAM (MiB)",
        budgetFreed: "Вільний бюджет навчання (ГБ)",
        budgetInferenceTarget: "Ціль інференсу на одній GPU (ГБ)",
        diagramTitle: "Згенерована діаграма архітектури",
        diagramSubtitle: "Детерміновано згенерована зі збереженої специфікації; поряд із даними не існує намальованої вручну діаграми.",
        noDiagram: "Відповідь не містить діаграми.",
        stagesTitle: "Ступенева будова архітектури",
        stagesSubtitle: "Безпосередньо зі збереженої специфікації; значення параметрів — проєктні.",
        stageCol: "Ступінь",
        layersCol: "Шари",
        mechanismCol: "Механізм",
        paramsCol: "Фізичні параметри (млрд) та першоджерела",
        paramsCross: "наскрізний — врахований у ступенях",
        researchTitle: "Дослідницький архів квантового та frontier-ШІ",
        researchSubtitle: "Живі рядки з дослідницького архіву Veridion Core; нові публікації надходять через інструмент квантового колеги, кожна з видимим походженням.",
        researchEmpty: "В архіві ще немає публікацій.",
        evidenceTitle: "Докази оцінювання",
        evidenceSubtitle: "Тут з'являються лише виміряні оцінювання з посиланнями; без доказу немає балу.",
        evalMetric: "Метрика",
        evalBenchmark: "Бенчмарк",
        evalSuite: "Набір",
        evalScore: "Значення",
        evalEvaluator: "Оцінювач",
        evalDate: "Виміряно",
        evalArtifact: "Артефакт доказу",
        gateTitle: "Правила підвищення (шлюз доказів)",
        gateMetrics: "Обов'язкові метрики",
        gateEpsilon: "Допуск (епсилон)",
        gateConfigVersion: "Конфігурація шлюзу (версія)",
        candidatesTitle: "Черга кандидатів",
        candidatesSubtitle: "Подані кандидати архітектури зі станом їхніх доказів; подання йде через дослідницьке середовище, ніколи через панель.",
        candidateSubmittedBy: "Подано ким",
        candidateEvidence: "Докази (наявні / потрібні)",
        candidatesEmpty: "Кандидатів не подано.",
        changelogTitle: "Журнал змін проєкту",
        changelogSubtitle: "Замінені проєктні ітерації — свідомо без показників: для них ніколи нічого не вимірювали.",
        changelogSummary: "Підсумок",
        changelogEmpty: "Немає заміненого проєкту.",
        supersededAt: "Замінено",
        eventsTitle: "Події шлюзу",
        eventsSubtitle: "Подання, підвищення, відхилення та перемикання заморозки так, як їх зафіксував шлюз.",
        eventsEmpty: "Подій ще немає.",
      },
      title: 'Розробка програм',
      subtitle: 'Завдання агента програмування, GitLab компанії з синхронізацією з Azure DevOps, merge requests, що чекають на рев’ю, і межі вузла GitLab.',
      openGitlab: 'Відкрити GitLab',
      openSonar: 'Відкрити SonarQube',
      loading: 'Завантаження …',
      failed: 'Не вдалося',
      done: 'Готово',
      unavailable: 'Недоступно',
      capacityTitle: 'Вузол GitLab',
      capacitySubtitle: 'Охоронець щохвилини встановлює межі вузла за навантаженням сервера; продакшн зберігає свій резерв.',
      stateLabel: 'Стан',
      memory: 'Пам’ять',
      cpu: 'CPU',
      disk: 'Диск',
      hostFree: 'Вільно на сервері',
      reserve: 'Резерв для продакшну',
      codingSlots: 'Завдань одночасно',
      pipelineQuota: 'Завдання конвеєра',
      recentActions: 'Останні дії охоронця',
      syncTitle: 'Синхронізація з Azure DevOps',
      syncSubtitle: 'Master у GitLab слідує за master в Azure; коміти, які мав лише GitLab, зберігаються під тегом replaced/<час>.',
      syncNow: 'Синхронізувати зараз',
      syncStarted: 'Синхронізацію запущено',
      azureCommit: 'Master в Azure',
      gitlabCommit: 'Master у GitLab',
      lastChange: 'Остання зміна',
      lastRun: 'Останній запуск',
      replaced: 'Збережено під тегами',
      noneReplaced: 'нічого',
      jobs: 'Останні запуски',
      error: 'Помилка',
      readyTitle: 'Merge requests, готові до рев’ю',
      readySubtitle: 'Лише merge requests із зеленим конвеєром; злиття виконується в GitLab.',
      noReady: 'Жоден merge request не чекає на рев’ю.',
      tasksTitle: 'Завдання програмування',
      tasksSubtitle: 'Кожна робота агента програмування зі станом, merge request і токенами.',
      showFinished: 'Показати завершені завдання',
      task: 'Завдання',
      requester: 'Замовник',
      statusLabel: 'Стан',
      mergeRequest: 'Merge request',
      pipeline: 'Конвеєр',
      tokens: 'Токени',
      updated: 'Оновлено',
      noTasks: 'Ще немає завдань програмування.',
      phase: 'Крок',
      repository: 'Репозиторій',
      branch: 'Гілка',
      openQuestion: 'Відкрите питання',
      result: 'Результат',
      sendMessage: 'Написати завданню',
      answerQuestion: 'Відповісти на питання',
      urgent: 'Терміново: одразу скерувати поточний крок',
      send: 'Надіслати',
      messageSent: 'Доставлено завданню',
      confirmCancel: 'Скасувати це завдання? Відкритий merge request буде закрито.',
      course: 'Перебіг сесії',
      messages: 'Повідомлення',
      events: 'Події',
      none: 'немає',
      close: 'Закрити',
      newTitle: 'Нове завдання',
      newSubtitle: 'Дайте агенту програмування завдання звідси; стежте за ним тут і на його картці у Webex.',
      brief: 'Що має зробити агент?',
      issue: 'Задача YouTrack (необов’язково)',
      create: 'Створити завдання',
      created: 'Завдання створено',
      usersTitle: 'Адміністратори в GitLab',
      usersSubtitle: 'Кожен адміністратор має користувача GitLab із правами адміністратора; housekeeping узгоджує їх із Keycloak.',
      email: 'E-mail',
      gitlabUser: 'Користувач GitLab',
      lastHousekeeping: 'Останній housekeeping',
      sonarDeleted: 'Проєкти SonarQube видалених гілок прибрано',
      previewsTitle: 'Проєкти в розробці',
      previewsSubtitle: 'Кожен проєкт у розробці працює рівно один раз від першого злиття: Veridion Core запускає найновіший зелений стан основної гілки (migration або master) у контейнерах за адміністраторським входом, оновлює його з кожним зеленим pipeline, а контейнери запускаються, зупиняються і перезапускаються тут. Проєкт, чий pipeline не збирає нічого робочого, стоїть тут із причиною.',
      previewsSummaryTitle: 'Що показує цей вигляд',
      previewsSummaryBody: 'Кожен проєкт у розробці працює як власний контейнер попереднього перегляду за адміністраторським входом. Список угорі показує найновіший робочий стан кожного проєкту, таблиця нижче — запущені контейнери зі станом, адресою та керуванням: відкрити, запустити, зупинити, перезапустити.',
      previewProject: 'Проєкт',
      previewState: 'Робочий стан',
      previewSince: 'Від',
      previewAddress: 'Адреса',
      previewMergedAt: 'Злито',
      noPreviews: 'Жоден проєкт не працює.',
      reasonsLabel: 'Причини блокування та Діагностика',
      noProjects: 'Немає проєкту в розробці.',
      qualityCoverage: 'Покриття тестами',
      qualityBugs: 'Помилки',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Дублювання',
      qualityHotspots: 'Відкриті hotspots',
      qualityUnavailable: 'Немає вимірів SonarQube',
      openPreview: 'Відкрити',
      startPreview: 'Запустити контейнери',
      stopPreview: 'Зупинити контейнери',
      previewStarted: 'Контейнери запущено',
      previewStopped: 'Контейнери зупинено',
      restartPreview: 'Перезапустити контейнери',
      previewRestarted: 'Контейнери перезапущено',
      previewControl: 'Контейнери',
      resultTitle: 'Результат у GitLab',
      resultJobs: 'Завдання та артефакти',
      resultSonar: 'SonarQube',
      resultDelivered: 'Доставлено',
      previewStatus: {
        starting: 'запускається',
        running: 'працює',
        stopped: 'зупинено',
        failed: 'невдалий',
      },
      capacityStates: {
        ok: 'у межах',
        tight: 'тісно: продакшну потрібне місце',
        full: 'заповнено: нової роботи немає',
        node_down: 'вузол не працює',
      },
      status: {
        queued: 'чекає на вільне місце',
        working: 'у роботі',
        waiting: 'чекає на відповідь',
        review: 'на рев’ю',
        merged: 'злито в GitLab',
        done: 'готово',
        needs_person: 'потрібна людина',
        rejected: 'закрито без злиття',
        paused: 'призупинено',
        cancelled: 'скасовано',
        failed: 'не вдалося',
      },
      commands: {
        pause: 'Призупинити',
        resume: 'Продовжити',
        cancel: 'Скасувати',
      },
      repositoryChoice: {
        auto: 'Агент вирішує',
        company: '{project} (злиття людиною)',
        own: 'Власний проєкт у {group}',
      },
      userState: {
        ok: 'узгоджено',
        created: 'створено',
        unblocked: 'розблоковано',
        'made administrator': 'призначено адміністратором',
        blocked: 'заблоковано',
      },
    },
    org: {
      write: 'Написати',
      call: "Подзвонити",
      callTitle: "Розмова з {bot}",
      writeTitle: 'Повідомлення для {bot}',
      callConfirmEnd: 'Завершити дзвінок?',
      callSubtitle: 'Мікрофон працює протягом усієї розмови. Бот вітає своїм голосом, відповідає коротко, перепитує щодо відкритих питань, і його можна перебити. Кожне речення також залишається у Webex, у прямій кімнаті з ботом.',
      callRinging: "Дзвонить …",
      callConnected: "З’єднано",
      callEnded: "Завершено",
      callEndedHangup: "Ви поклали слухавку",
      callEndedClosed: "З’єднання було закрито",
      callEndedSilence: "90 секунд тиші",
      callEndedLimit: "Досягнуто межі в 30 хвилин",
      callEndedError: "Помилка завершила розмову",
      callHangUp: "Покласти слухавку",
      callLevel: "Рівень мікрофона",
      callYou: "Ви",
      callSpeaking: "Бот говорить …",
      callThinking: 'Відповідь генерується …',
      callOvertaken: "випереджено вашим наступним запитанням, не промовлено",
      callNothingHeard: "Слів не почуто.",
      callMicDenied: "Браузер відмовив у доступі до мікрофона; дозвольте його для цієї сторінки і подзвоніть знову.",
      callNoVoice: "Голос зараз недоступний; відповідь залишається текстом.",
      callRefused: "Дзвінок не прийнято: квиток був недійсний або прострочений; подзвоніть знову.",
      callFailed: "Розмова не вдалася",
      voice: "Голос",
      voiceHint: "Голос, яким говорить цей колега: у Webex, коли людина просить почути відповідь, і по телефону. Типово це диктор аудіомоделі в OpenRouter; власний, клонований голос зі сховища голосів говорить через голосовий рушій платформи.",
      voiceSave: "Зберегти голос",
      voiceDefault: "за замовчуванням",
      voiceNone: "без голосу",
      voiceCloud: "Диктори OpenRouter (типово)",
      voiceOwn: "Власні голоси (клоновані)",
      voiceUploadTitle: "Завантажити зразок голосу для цього колеги",
      voiceUploadHint: "Аудіо або відео, не більше 25 МБ; Core перетворює зразок, залишає до 20 секунд, чує його слова і зберігає лише еталонний кліп. Колега одразу говорить цим голосом.",
      voiceUploadName: "Назва голосу",
      voiceUploadConsent: "Підтверджую, що маю право використовувати цей голос для компанії: він мій або особа дала згоду.",
      voiceUploadButton: "Завантажити зразок",
      voiceUploadDone: "Голос збережено",
      voiceTooLarge: "Файл більший за 25 МБ.",
      voicesTitle: "Голоси",
      voicesSubtitle: "Кожен голос компанії — еталонний кліп у сховищі голосів Veridion Core; голосовий рушій клонує його щоразу, коли бот говорить. Дев’ять попередніх дикторів стоять у ньому як захоплені кліпи.",
      voiceSeconds: "Секунди",
      voiceSource: "Походження",
      voiceSourcePreset: "захоплений диктор",
      voiceSourceUpload: "завантажений зразок",
      voiceAddedBy: "Додав",
      voiceConsentBy: "Згоду підтвердив",
      voiceWords: "Слова кліпу",
      voiceDelete: "Видалити",
      voiceConfirmDelete: "Видалити цей голос? Колеги, які його використовують, знову говоритимуть своїм голосом за замовчуванням.",
      voiceCapture: "Захопити дикторів рушія з пресетами",
      voiceCaptureHint: "Промовляє одне фіксоване речення на диктора через рушій з пресетами і зберігає його як кліп; виконується перед зміною рушія.",
      voiceCaptured: "Захоплено",
      voiceEnginePresets: "Голосовий рушій пропонує фіксованих дикторів; сховище голосів не використовується.",
      chartTitle: "Організаційна схема",
      executiveTitle: 'Керівний рівень',
      unitsTitle: 'Бізнес-підрозділи',
      unitLead: 'Керівник',
      unitSupporting: 'За підтримки',
      unitMission: 'Місія',
      unitPrefix: 'Префікс треду',
      standingActive: 'активний',
      standingStandby: 'у режимі очікування',
      standbyOn: 'Перевести в очікування',
      standbyOff: 'Активувати',
      standbyHint: 'У режимі очікування колега не робить жодного ходу з власної ініціативи компанії й не витрачає токенів; на пряме повідомлення від людини він і далі відповідає.',
      confirmStandby: 'Перевести {name} в очікування?',
      confirmActivate: 'Активувати {name}?',
      activity: 'Діяльність',
      runtime: 'Середовище виконання',
      modelCloud: 'хмарна модель',
      modelGpu: 'двигун компанії',
      callModel: 'Телефонна модель',
      calls30: 'Дзвінки, останні 30 днів',
      telemetryLine: '{model} · {prompt}+{completion} токенів · {cost} · вухо {asr} ms · розум {llm} ms · голос {tts} ms · разом {total} ms{deferred}',
      telemetryDeferred: ' · {count} відкладено',
      chartSubtitle: "ШІ-колеги Veridion: агенти у Veridion Core, кожен доступний як власний бот Webex, за напрямами; над ними люди, що ухвалюють рішення, під ними агенти без власного бота і простори компанії, прочитані наживо з Veridion Core і Webex.",
      chartPeople: "Особи, що ухвалюють рішення",
      chartPeopleText: "Люди, що ухвалюють рішення, вирішують усе і діють у {space}.",
      chartAgentsTitle: "Агенти без власного бота: агент кодування, оркестратор MCP Veridion і агенти, яких будує архітект, працюють від імені ШІ-колеги і говорять через його бота",
      chartDesigned: "Агенти, створені з архітектором",
      chartFor: "Від імені",
      chartSystemsTitle: "Під'єднані системи",
      chartSpaceHome: "Домашній простір для",
      chartSpacePurpose: "Призначення",
      chartRoomsTitle: "Простори компанії у Webex",
      room: "Простір",
      roomBots: "Боти",
      positionsTitle: "ШІ-колеги",
      positionsSubtitle: "Кожен ШІ-колега відповідає через власного бота та читає свої простори. Його опис — це інструкція, за якою він працює.",
      bot: "Бот",
      position: "Функція",
      statusLabel: "Стан",
      tokensUsed: "Використані токени",
      tokens30: "Токени, останні 30 днів",
      edit: "Редагувати",
      close: "Закрити",
      description: "Опис ШІ-колеги",
      save: "Зберегти",
      resetDescription: "Відновити стандартний опис",
      interests: "Профіль інтересів",
      interestsHint: "Які види пунктів і теми стосуються цього ШІ-колеги і коли вони його не стосуються. За ним ШІ-колега оцінює кожне повідомлення у своїх просторах.",
      threshold: 'Поріг для висловлень без запиту',
      thresholdHint: 'Від 1 до 5: наскільки сильно повідомлення має стосуватися ШІ-колеги, щоб він висловився без запиту. При 1 він висловлюється вже за низької дотичності, при 5 лише за високої.',
      saveProfile: "Зберегти профіль",
      tools: "Інструменти",
      decisionMakersTitle: "Особи, що ухвалюють рішення",
      decisionMakersSubtitle: "Кожна з них може надати будь-яке погодження та відповісти на будь-яке запитання ШІ-колеги у Webex.",
      email: "Адреса електронної пошти",
      add: "Додати",
      remove: "Вилучити",
      confirmRemove: "Вилучити цю особу?",
      readerTitle: "Читання просторів компанії",
      readerSubtitle: "Бот бачить лише повідомлення, у яких його згадано. Veridion читає кожне повідомлення просторів компанії завдяки дозволу облікового запису, що є учасником усіх просторів.",
      notConfigured: "Інтеграцію не налаштовано",
      authorised: "Дозволено",
      notAuthorised: "Не дозволено",
      account: "Обліковий запис",
      validUntil: "Токен доступу дійсний до",
      renewUntil: "Дозвіл можна поновлювати до",
      authorise: "Дозволити читання",
      authoriseAgain: "Дозволити знову",
      linkOpened: "Вхід у Webex відкрито в новій вкладці.",
      found: "знайдено",
      notFound: "не знайдено",
      botsInSpace: "боти",
      transcripts: "Стенограми зустрічей",
      yes: "так",
      no: "ні",
      approvalsTitle: "Відкриті погодження",
      approvalsSubtitle: "Погодження та запитання, про які просили ШІ-колеги і на які ще ніхто з тих, хто ухвалює рішення, не відповів.",
      originSpace: "Простір",
      directRoom: "особиста розмова",
      approvalKinds: { review: "погодження", question: "запитання" },
      schedulesTitle: "Розклади",
      schedulesSubtitle: "Повторювана робота, про яку попросили в просторі; вона триває, доки її хтось не завершить.",
      createdBy: "замовив",
      lastRun: "останній запуск",
      end: "Завершити",
      confirmEnd: "Завершити цей розклад?",
      none: "Немає",
      loading: "Завантаження…",
      failed: "Не вдалося",
      working: "Виконується…",
      done: "Готово",
      memoryTitle: "Організація",
      memorySubtitle: "Люди та ШІ-колеги компанії з областю пам'яті, у якій працює кожен ШІ-колега.",
      memoryMember: "Учасник",
      area: "Напрям",
      decisionMaker: "Ухвалює рішення",
      status: { running: "працює" },
    },
    core: {
      conversationTitle: 'Розмова з панелі керування',
      conversationHint: 'Кожне повідомлення і кожна відповідь також промовляються у Webex: у гілці роботи агента, інакше у вашій прямій кімнаті з ботом.',
      conversationEmpty: 'Повідомлень з панелі керування ще немає.',
      writeToAgent: 'Повідомлення цьому агенту',
      answerPending: 'Відповідь очікується',
      title: 'Veridion Core',
      subtitle: 'Агентна операційна система за корпоративним ботом: його агенти, їхні повідомлення та споживання токенів, визначення, архітектор і організація.',
      done: 'Готово.',
      failed: 'Не вдалося',
      loading: 'Завантаження …',
      working: 'Виконується …',
      none: 'Немає.',
      unavailable: 'Veridion Core недоступний',
      errors: {
        AGENT_FINISHED: 'Агент завершив роботу й більше не приймає повідомлень',
        EMERGENCY_STOP: 'Аварійну зупинку ввімкнено',
        DEFINITION_INVALID: 'Визначення недійсне',
        TOO_MANY_AGENTS: 'Запущено забагато агентів',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core не налаштовано',
        MESSAGE_EMPTY: 'Повідомлення порожнє',
      },
      status: {
        building: 'збирання образу',
        starting: 'запускається',
        running: 'працює',
        waiting: 'очікує',
        idle: 'готовий',
        paused: 'призупинено',
        completed: 'завершено',
        failed: 'збій',
        cancelled: 'скасовано',
        stopped: 'зупинено',
        not_deployed: 'не розгорнуто',
      },
      statusLabel: 'Статус',
      owner: 'Власник',
      definition: 'Визначення',
      parent: 'Батьківський агент',
      tokens: 'Токени',
      progress: 'Перебіг',
      close: 'Закрити',
      openQuestion: 'Відкрите питання',
      result: 'Результат',
      answerQuestion: 'Відповісти на питання',
      sendMessage: 'Повідомлення агенту',
      urgent: 'Терміново: перервати поточний крок',
      send: 'Надіслати',
      messageSent: 'Доставлено агенту.',
      commands: {
        pause: 'Призупинити',
        resume: 'Продовжити',
        cancel: 'Скасувати',
        kill: 'Негайно завершити',
      },
      confirmKill: 'Негайно завершити цього агента та його субагентів?',
      subAgents: 'Субагенти',
      graph: 'Граф',
      messages: 'Повідомлення',
      messageStatus: {
        queued: 'у черзі',
        delivered: 'доставлено',
        consumed: 'прочитано',
        refused: 'відхилено',
      },
      events: 'Події',
      containerLog: 'Журнал контейнера',
      version: 'Версія',
      activeAgents: 'Активні агенти',
      updated: 'Оновлено',
      archived: 'в архіві',
      noDefinitions: 'Визначень поки немає.',
      versions: 'Версії',
      from: 'з',
      startInput: 'Початкові вхідні дані у форматі JSON',
      agentStarted: 'Агента запущено.',
      startAgent: 'Запустити агента',
      editAsJson: 'Редагувати як JSON',
      confirmArchive: 'Архівувати це визначення? Запущені агенти продовжать роботу.',
      archive: 'Архівувати',
      definitionJson: 'Визначення у форматі JSON',
      definitionJsonHint: 'Визначення мовою графів Veridion. Перевірка показує його недоліки та граф; збереження записує його як нову затверджену версію.',
      checked: 'Перевірено.',
      validate: 'Перевірити',
      saved: 'Збережено як нову версію.',
      saveVersion: 'Зберегти як нову версію',
      valid: 'Визначення дійсне.',
      you: 'Ви',
      architect: 'Архітектор',
      architectPlaceholder: 'Опишіть, що має робити агент …',
      newDesign: 'Новий проєкт',
      unitKinds: {
        company: 'компанія',
        department: 'відділ',
        team: 'команда',
        project: 'проєкт',
      },
      partOf: 'входить до',
      confirmRemove: 'Видалити цей підрозділ? Його учасники втратять цю сферу доступу.',
      remove: 'видалити',
      addUnit: 'Додати підрозділ',
      unitId: 'Ідентифікатор (малі літери, дефіси)',
      unitName: 'Назва',
      add: 'Додати',
      addMember: 'Додати учасника',
      memberKinds: {
        person: 'особа (адреса електронної пошти)',
        agent: 'агент (ідентифікатор)',
        definition: 'визначення (ідентифікатор)',
      },
      memberId: 'Адреса електронної пошти або ідентифікатор',
      role: 'Роль',
      confirmEmergencyOn: 'Зупинити всіх агентів зараз? Бот і далі відповідатиме.',
      confirmEmergencyOff: 'Зняти аварійну зупинку?',
      emergencyStop: 'Аварійна зупинка',
      emergencyRelease: 'Зняти аварійну зупинку',
      emergencyActive: 'аварійну зупинку ввімкнено',
      autopilotOn: 'Увімкнути автопілот',
      autopilotOff: 'Вимкнути автопілот',
      autopilotActive: 'Автопілот активний: Veridion Core сам відповідає на кожну картку для людей',
      autopilotUnitsTitle: 'Автопілот за бізнес-підрозділами',
      autopilotUnitsHint: 'Вмикає або вимикає автопілот окремо для кожного бізнес-підрозділу та виконавчого рівня. Призупинена робота залишається недоторканою.',
      autopilotUnitOn: 'Автопілот увімк.',
      autopilotUnitOff: 'Автопілот вимк.',
      limitsBuilds: 'Збірки образів на колегу й день',
      limitsDesigns: 'Проєкти агентів на колегу й день',
      limitsSave: 'Задати денні ліміти',
      limitsNone: '0 = без обмеження',
      confirmAutopilotOn: 'Увімкнути автопілот? Власний ухвалювач рішень Veridion Core одразу відповідатиме на кожну відкриту й нову картку в pAIoneer-humans-and-bots, видимо у гілці картки.',
      confirmAutopilotOff: 'Вимкнути автопілот? Відтоді знову вирішують люди.',
      model: 'Модель',
      codingModel: 'Модель для програмування',
      modelsTitle: 'Моделі за ролями',
      modelsSubtitle: 'На якій моделі думає кожна роль Veridion Core: обличчя й керування компанії, телефон, архітектор і суддя вердиктів з вимог. Обирати можна лише моделі, які маршрутизує шлюз; порожнє означає типове значення конфігурації.',
      roleCoordinator: 'Координатор (обличчя й керування)',
      roleCall: 'Телефон',
      roleArchitect: 'Архітектор',
      roleRequirementsJudge: 'Суддя з вимог',
      roleJudge: 'Судження Core',
      roleEar: 'Вухо телефону',
      roleStt: 'Вухо Webex',
      modelGroupVllm: 'vLLM (власна карта)',
      modelGroupAudio: 'Аудіо (власна карта / хмара)',
      modelGroupCloud: 'OpenRouter (хмара)',
      directLlmTitle: 'Прямий доступ до LLM',
      directLlmSubtitle: 'Спілкуйтеся напряму з vLLM або хмарною моделлю, без ботів, агентів чи Webex',
      directLlmHint: 'Прямий доступ адміністратора: обрана модель відповідає сирою, облік під „console“, без lanes, ролей чи інструментів.',
      directLlmModel: 'Модель',
      directLlmSystem: 'Системний промпт (необовʼязково)',
      directLlmSystemPlaceholder: 'напр. Ти …',
      directLlmPrompt: 'Повідомлення',
      directLlmPromptPlaceholder: 'Що ви хочете запитати модель напряму?',
      directLlmSend: 'Надіслати',
      directLlmSending: 'Надсилання …',
      directLlmUsage: '{prompt}+{completion} токенів · {cost}',
      modelCurrent: 'Використовується',
      modelDefault: 'Типова',
      modelChosen: 'Обрана',
      modelDefaultOption: 'типове значення конфігурації',
      modelNotRouted: 'шлюз не маршрутизує',
      modelSave: 'Зберегти',
      engineSilver: 'Двигун компанії (срібло)',
      engineGold: 'Двигун компанії (золото, оркестратора)',
      callsTitle: 'Телефонні дзвінки',
      callsSubtitle: 'Кожен вимовлений хід телефону, облікований окремо від роботи колег: токени, вартість і час вуха, розуму та голосу, за колегою і моделлю, за останні 30 днів і сьогодні; нижче найновіші ходи.',
      callsTurns: 'Ходи',
      callsCalls: 'Дзвінки',
      callsAvgTotal: 'Ø разом ms',
      callsAvgAsr: 'Ø вухо ms',
      callsAvgLlm: 'Ø розум ms',
      callsAvgTts: 'Ø голос ms',
      callsDeferred: 'Відкладено',
      callsToday: 'Сьогодні',
      callsWindow: 'Останні 30 днів',
      callsRecent: 'Найновіші ходи',
      callsPerson: 'Особа',
      callsRounds: 'Раунди',
      callsNone: 'Ще жодного дзвінка не обліковано.',
      unitKindExecutive: 'Керівний рівень',
      unitKindBusinessUnit: 'Бізнес-підрозділ',
      orgSynced: 'Керівний рівень і бізнес-підрозділи визначені в організації Veridion Core й синхронізовані сюди; їх змінюють там, а не на цій сторінці.',
      memory: 'Пам\'ять',
      ready: 'готово',
      notReady: 'не готово',
      factExtraction: 'вилучення фактів увімкнено',
      cluster: 'Доступ до кластера',
      agentsRunning: 'Активні агенти',
      agentsWaiting: 'очікують',
      definitions: 'Визначення',
      gatewayIdentity: 'Ідентичність у шлюзі',
      gatewayTokens: 'Токени шлюзу в часовому вікні',
      hostedTitle: 'Розміщені агенти',
      hostedSubtitle: 'ШІ-застосунки, які Veridion Core запускає та обслуговує у власних контейнерах.',
      agent: 'Агент',
      actions: 'Дії',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'запустити',
        stop: 'зупинити',
        restart: 'перезапустити',
      },
      open: 'відкрити',
      agentsTitle: 'Агенти',
      agentsSubtitle: 'Кожен агент і субагент працює у власному контейнері. Відкрийте його, щоб надіслати повідомлення або керувати ним.',
      showFinished: 'Показати завершених агентів',
      noAgents: 'Агентів немає.',
      definitionsTitle: 'Визначення',
      definitionsSubtitle: 'Затверджені графи агентів з їхніми версіями.',
      designsTitle: 'Проєкти агентів',
      designsSubtitle: 'Кожен агент, якого спроєктував архітектор, для людини або для роботи ШІ-колеги: для чого і чому, кожне питання з відповіддю, тестові запуски проти сценаріїв, затвердження і запуски.',
      design: 'Проєкт',
      designFor: 'Для',
      designWork: 'Робота',
      designState: 'Стан',
      designApprovedBy: 'Затвердив',
      designAgent: 'Створений агент',
      filterState: 'Стан',
      filterAll: 'Усі',
      filterOpen: 'Відкриті',
      filterDone: 'Готові',
      filterFailed: 'Невдалі',
      filterCurrent: 'Активні та нещодавно невдалі',
      filterActive: 'Активні',
      filterFinished: 'Завершені',
      filterPosition: 'ШІ-колега',
      pagePrev: 'Назад',
      pageNext: 'Далі',
      pageLabel: 'Сторінка',
      searchLabel: 'Пошук',
      showMore: 'Показати більше',
      noDesigns: 'Ще не спроєктовано жодного агента.',
      designReason: 'Чому інструментів не вистачило',
      designRecord: 'Перебіг',
      designAgents: 'Агенти проєкту',
      designTestRun: 'Тестовий запуск',
      designRun: 'Запуск',
      designStatus: { designing: 'проєктується', testing: 'тестується', asking: 'чекає відповіді', approval: 'чекає затвердження', running: 'працює', done: 'готово', failed: 'не вдалося', cancelled: 'скасовано' },
      builtBy: 'Створено',
      builtFor: 'Для роботи',
      viaCodingTask: 'через агента програмування',
      designTests: 'Тестові запуски',
      designRuns: 'Запуски',
      designByPerson: 'людина в розмові',
      diagramsTitle: 'Діаграми',
      diagramsSubtitle: 'Зображення процесів, архітектур і планів, накреслені ШІ-колегами, агентами та агентом програмування, із заголовком, легендою та кодом Mermaid.',
      noDiagrams: 'Ще немає діаграм.',
      diagramAuthor: 'Автор',
      diagramBasedOn: 'Розширює',
      diagramCode: 'Код Mermaid',
      architectTitle: 'Архітектор',
      architectSubtitle: 'Спроєктуйте агента в розмові. Архітектор запитує те, чого не може вирішити сам, і створює агента лише після Вашого затвердження.',
      orgTitle: 'Організація',
      orgSubtitle: 'Відділи, команди та проєкти з їхніми учасниками; пам\'ять компанії розподіляється відповідно до цієї структури.',
      usageTitle: 'Використання за агентами',
      usageSubtitle: 'Виклики моделей, токени та зафіксовані витрати за останні 30 днів.',
      calls: 'Виклики',
      source: 'Джерело',
      gpuTokens: 'Токени на відеокарті',
      cloudTokens: 'Токени у хмарі',
      usageByModel: 'За колегою та моделлю',
      cost: 'Витрати',
    },
    memory: {
      archOverviewTitle: "Огляд архітектури: як побудована пам'ять компанії",
      archOverviewText: "Veridion Core зберігає знання компанії у трьох шарах: Neo4j як часовий граф знань для фактів, рішень і робочих пакетів, PostgreSQL для транзакційних станів агентів, скриньок і спринтів та Qdrant для векторного пошуку по документах компанії. Кожен бізнес-підрозділ працює у фахово ізольованому домені знань; результати між підрозділами проходять через запротокольовані передачі.",
      clustersTitle: "Домени знань бізнес-підрозділів",
      clustersSubtitle: "Кожен бізнес-підрозділ працює у відокремленому домені знань Neo4j; кількість вузлів і ребер надходить наживо з Neo4j, описи — з позначеного початкового наповнення. Клік відкриває домен у графі знань.",
      clusterCode: "Код",
      clusterName: "Домен знань",
      clusterId: "Ідентифікатор",
      clusterRoles: "Ролі",
      clusterBridges: "Мости передач",
      clusterPolicy: "Фаховий фокус та правило ізоляції",
      clusterCounts: "Вузли / ребра (наживо)",
      clusterInsights: "Висновки (початкове наповнення)",
      clusterOpenButton: "Відкрити у графі знань",
      countsUnavailable: "Neo4j недоступний — без підрахунку",
      researchTitle: "Дослідницький архів квантового та frontier-ШІ",
      researchSubtitle: "Ключові наукові публікації та архітектурні референції — живі рядки з Veridion Core; походження кожного рядка видно.",
      researchEmpty: "В архіві ще немає публікацій.",
      researchIngestNote: "Нові публікації додає квантовий колега через свій інструмент; панель лише читає архів.",
      researchPublication: "Публікація",
      researchMechanism: "Ключовий механізм",
      researchRelevance: "Значущість для архітектури",
      researchOrigin: "Походження",
      researchSeeded: "початкове наповнення",
      researchMotivates: "Обґрунтовує версію",
      title: 'Пам\'ять компанії',
      subtitle: 'Що Veridion Core зберігає в Neo4j: спогади за сферами, факти з періодом їхньої чинності та аудит дій агентів.',
      failed: 'Не вдалося',
      loading: 'Завантаження …',
      unavailable: 'Пам\'ять недоступна',
      database: 'База даних',
      ready: 'готово',
      notReady: 'не готово',
      factExtraction: 'Вилучення фактів',
      episodesQueued: 'Епізоди в черзі',
      lastError: 'Остання помилка',
      contentTitle: 'Вміст',
      contentSubtitle: 'Вузли за мітками та спогади за сферами й типами.',
      label: 'Мітка',
      count: 'Кількість',
      empty: 'Поки нічого.',
      scope: 'Сфера',
      kind: 'Тип',
      kinds: {
        fact: 'факт',
        decision: 'рішення',
        task: 'завдання',
        procedure: 'процедура',
        note: 'нотатка',
        episode: 'епізод',
      },
      searchTitle: 'Пошук',
      searchSubtitle: 'Пошук, яким користуються агенти: зміст, слова та вилучені факти.',
      searchPlaceholder: 'Пошуковий запит або питання',
      allScopes: 'усі сфери',
      search: 'Шукати',
      noResults: 'Нічого не знайдено.',
      text: 'Текст',
      validFrom: 'Чинний з',
      source: 'Джерело',
      extracted: 'вилучено',
      recorded: 'записано',
      rememberTitle: 'Запам\'ятати',
      rememberSubtitle: 'Зберегти факт, рішення, завдання, процедуру або нотатку в певній сфері.',
      remembered: 'Збережено.',
      remember: 'Запам\'ятати',
      created: 'Створено',
      validity: 'Чинність',
      invalid: 'недійсний',
      confirmInvalidate: 'Позначити цей спогад як більше не чинний?',
      invalidate: 'позначити недійсним',
      forget: 'забути',
      confirmForget: 'Остаточно забути цей запис? Його буде видалено з пам\'яті без можливості відновлення.',
      forgotten: 'Забуто.',
      factsTitle: 'Факти в часі',
      factsSubtitle: 'Факти з розмов і результатів агентів; спростований факт отримує дату завершення.',
      noFacts: 'Фактів ще не вилучено.',
      briefsTitle: 'Зведення ШІ-колег',
      briefsSubtitle: 'Що кожен ШІ-колега читає першим: відкриті зобов\'язання, чинні рішення, поточні справи та клієнти, щоночі складене з пам\'яті.',
      brief: 'Зведення',
      updated: 'Оновлено',
      noBriefs: 'Зведень ще не складено.',
      fact: 'Факт',
      from: 'Від',
      to: 'До',
      validUntil: 'Чинний до',
      stillValid: 'досі чинний',
      entityTitle: 'Оточення',
      entitySubtitle: 'З чим пов\'язані завдання, проєкт, особа, система чи сутність.',
      entityPlaceholder: 'Ім\'я, ідентифікатор завдання, адреса електронної пошти або ідентифікатор',
      show: 'Показати',
      auditTitle: 'Аудит',
      auditSubtitle: 'Виклики моделей та інструментів, повідомлення й запущені субагенти.',
      auditPlaceholder: 'Ідентифікатор агента (порожньо: усі)',
      filter: 'Фільтрувати',
      time: 'Час',
      agent: 'Агент',
      event: 'Подія',
      toolOrModel: 'Інструмент або модель',
      status: 'Статус',
      detail: 'Подробиці',
      consoleTitle: 'Консоль запитів',
      consoleSubtitle: 'Лише читання Cypher; інструкції на запис відхиляються.',
      run: 'Виконати',
      truncated: 'решту рядків обрізано',
      graph: {
        clusterPickTitle: "Сфокусувати домен знань у графі",
        clusterPickHint: "Клік на бізнес-підрозділ фокусує його підграф з ролями та мостами передач в інтерактивному графі.",
        allClusters: "Усі домени (повний граф)",
        activeCluster: "Активний домен знань",
        publicationsTitle: "Публікації у дослідницькому архіві",
        storesTitle: 'Сховища пам\'яті компанії',
        storesSubtitle: 'Що містить кожне сховище пам\'яті компанії, прочитане наживо: граф у Neo4j, стан Veridion Core у Postgres, вектори бази знань у Qdrant.',
        storeNeo4j: 'Neo4j (граф)',
        storeNeo4jHolds: 'Пам\'ять компанії: спогади з їхньою областю, сутності та факти, видобуті Graphiti, з періодом чинності, робочі елементи з їхнім значенням, програмна робота та аудит агентів.',
        storePostgres: 'Postgres (реляційна)',
        storePostgresHolds: 'Транзакційний стан Veridion Core: таблиця процесів агентів, поштові скриньки, розмови, контрольні точки, завдання з кодування, погодження, організація та споживання.',
        storeQdrant: 'Qdrant (вектори)',
        storeQdrantHolds: 'База знань компанії: вбудовані фрагменти документів, доданих адміністратором, у яких оркестратор шукає, коли хід розмови потребує бази знань.',
        nodes: 'вузлів',
        relationships: 'зв\'язків',
        relationshipType: 'Тип зв\'язку',
        tables: 'таблиць',
        table: 'Таблиця',
        rows: 'рядків',
        purpose: 'Що містить',
        documents: 'документів',
        session: 'Сесія',
        collection: 'Колекція',
        role: 'Роль',
        roleDocuments: 'документи',
        roleCurated: 'відібрані пари запитання-відповідь',
        title: 'Граф',
        subtitle: 'Граф пам\'яті компанії в Neo4j: почніть із результату пошуку, найновіших спогадів або робочих елементів; клацніть вузол, щоб прочитати його, розгорніть його сусідів, перетягуйте для впорядкування, прокручуйте для масштабування.',
        startNewest: 'Найновіші спогади',
        startWork: 'Робочі елементи',
        searchPlaceholder: 'Назва, текст або ідентифікатор для пошуку в графі',
        find: 'Знайти',
        noHits: 'Нічого не знайдено.',
        name: 'Назва',
        sources: { memory: 'спогад', entity: 'видобута сутність', node: 'пам\'ять проєкту', episode: 'епізод' },
        show: 'показати',
        shown: '{nodes} вузлів і {edges} зв\'язків у графі',
        truncated: 'обрізано на межі; розгорніть вузол або шукайте вужче',
        selected: 'Вибраний вузол',
        selectHint: 'Клацніть вузол у графі.',
        expand: 'Розгорнути сусідів',
        expandTwo: 'Розгорнути два рівні',
        centre: 'Центрувати на цьому вузлі',
        facts: 'Факти цієї сутності',
        degree: 'Зв\'язки',
        direction: 'Напрям',
        out: 'вихідний',
        in: 'вхідний',
        noRelationships: 'Зв\'язків немає.',
        property: 'Властивість',
        value: 'Значення',
        noProperties: 'Властивостей немає.',
        factsOf: 'Факти про',
        factsSubtitle: 'Що Graphiti видобув про цю сутність, із періодом чинності кожного факту; спростований факт має дату завершення.',
        relation: 'Зв\'язок',
        other: 'Інша сутність',
        newestTitle: 'Найновіші спогади',
        newestSubtitle: 'Останні записані спогади з тим, чого вони стосуються; «показати» малює один із його посиланнями.',
        about: 'Стосується',
        workTitle: 'Робочі елементи',
        workSubtitle: 'Кожна підтверджена робота зі станом, відповідальним, задачею та результатами її сценаріїв; «показати» малює одну з її значенням, задачею, завданнями з кодування та створеними для неї агентами.',
        allStates: 'усі стани',
        states: { confirmed: 'підтверджено', in_progress: 'у роботі', blocked: 'заблоковано', done: 'виконано', failed: 'невдало', dropped: 'відхилено' },
        workItem: 'Робочий елемент',
        owner: 'Відповідальний',
        issue: 'Задача',
        scenarios: 'Сценарії',
        results: { passed: 'пройдено', failed: 'не пройдено', pending: 'очікує' },
      },
      day: {
        title: 'День компанії',
        subtitle: 'Хронологія подій, які записує Veridion Core: слова людей, картки, робота, передачі, дослідження, агенти, завдання з кодування, проєкти, інциденти та зустрічі, найновіше спочатку.',
        sinceToday: 'сьогодні',
        sinceDay: 'останні 24 години',
        sinceWeek: 'останні 7 днів',
        allKinds: 'усі види',
        refresh: 'Оновити',
        count: '{n} подій',
        time: 'Час',
        actor: 'Учасник',
        happening: 'Подія',
        work: 'Робота',
        empty: 'За цей період нічого не записано.',
        kinds: { word: 'слово', request: 'запит', card: 'картка', work: 'робота', handover: 'передача', research: 'дослідження', agent: 'агент', task: 'завдання з кодування', project: 'проєкт', incident: 'інцидент', schedule: 'розклад', meeting: 'зустріч', message: 'повідомлення' },
      },
    },
    title: 'Панель адміністратора',
    adminKicker: 'Експлуатація',
    smtmStatusTitle: 'Дані та прогнози SMTM',
    smtmStatusSubtitle: 'Відстежує часові ряди брокера, опубліковані моделі, результати прогнозів і RSS-стрічки.',
    smtmStatusUnavailable: 'Стан SMTM недоступний',
    smtmGeneratedAt: 'Згенеровано',
    smtmMinimumRows: 'Мінімум рядків для навчання',
    smtmBaseFrames: 'Базові часові ряди',
    smtmTrainableFrames: 'Сирі дані готові',
    smtmWaitingHistory: 'Очікує на історію',
    smtmPredictionTrackedInstruments: 'Відстежувані інструменти',
    smtmPredictionEnabledCount: 'Прогнози увімкнено',
    smtmPredictionDisabledCount: 'Прогнози призупинено',
    smtmMlFrames: 'Набори даних ML',
    smtmOnlineModels: 'Моделі онлайн',
    smtmModelsWithArtifacts: 'Моделі з артефактами',
    smtmPredictionFrames: 'Ряди прогнозів',
    smtmMissingPredictions: 'Ряди без прогнозів',
    smtmBlobArtifacts: 'Blob-артефакти',
    smtmStalePredictions: 'Застарілі прогнози',
    smtmRssFrames: 'RSS-стрічки',
    smtmDataframesTotal: 'Усього наборів даних',
    smtmLatestModelUpload: 'Останнє завантаження моделі',
    smtmLatestPredictionWrite: 'Останній запис прогнозу',
    smtmRuntimeHints: 'Підказки середовища',
    smtmNoHints: 'Немає відкритих підказок SMTM.',
    smtmInstrument: 'Інструмент',
    smtmBaseData: 'Базові дані',
    smtmMlFrame: 'Набір даних ML',
    smtmModelPublish: 'Стан моделі',
    smtmArtifacts: 'Артефакти',
    smtmPredictionFrame: 'Ряд прогнозів',
    smtmIssues: 'Проблеми',
    smtmNoIssues: 'Проблем немає',
    smtmNoFrames: 'Інструментів SMTM не знайдено.',
    smtmPredictionControlTitle: 'Керування прогнозами SMTM',
    smtmPredictionControlSubtitle: 'Вирішуйте для кожного інструмента, чи має SMTM обчислювати нові прогнози машинного навчання, чи лише збирати базові дані.',
    smtmPredictionSettingsUnavailable: 'Керування прогнозами SMTM недоступне',
    smtmPredictionControlHint: 'Призупинені інструменти зберігають історичні дані. Нові набори ML, навчання та прогнози для них більше не створюються.',
    smtmPredictionMode: 'Режим прогнозу',
    smtmPredictionToggle: 'Керування адміністратора',
    smtmPredictionToggleLabel: 'Увімкнути або призупинити прогнози',
    smtmPredictionEnabled: 'Прогноз увімкнено',
    smtmPredictionDisabled: 'Прогноз призупинено',
    smtmPredictionSaving: 'Збереження...',
    smtmPredictionSettingsSaved: 'Керування прогнозами SMTM збережено.',
    smtmPredictionSaveChanges: 'Зберегти зміни',
    smtmPredictionResetChanges: 'Скасувати зміни',
    smtmPredictionPendingChanges: 'незбережених змін',
    smtmPredictionPendingBadge: 'Очікує збереження',
    smtmOpenAzuriteUi: 'Відкрити вебінтерфейс Azurite',
    azuriteTitle: 'Вебінтерфейс Azurite (SMTM)',
    azuriteSubtitle: 'Перегляд лише для читання записів modelstatus, blob-артефактів і завантажень моделей.',
    azuriteModelGroups: 'Групи моделей',
    azuriteBlobArtifacts: 'Blob-артефакти',
    azuriteFiles: 'Файли',
    azuriteSearchPlaceholder: 'Фільтрувати моделі',
    azuriteNoModels: 'Моделей Azurite не знайдено.',
    smtmRows: 'Рядки',
    smtmLatest: 'Остання позначка часу',
    smtmAge: 'Вік',
    smtmValue: 'Значення',
    smtmMinutesAgo: 'хв тому',
    smtmMinutesAhead: 'хв уперед',
    smtmHoursAgo: 'год тому',
    smtmDaysAgo: 'дн тому',
    smtmStateLabels: {
      available: 'Доступний',
      trainable: 'Придатний до навчання',
      waiting_for_history: 'Очікує на історію',
      missing_base_data: 'Немає базових даних',
      missing_machine_learning: 'Немає набору даних ML',
      missing_prediction: 'Немає прогнозу',
      prediction_disabled: 'Прогноз призупинено',
      stale_prediction: 'Застарілий прогноз',
      open: 'Відкрито',
      completed: 'Завершено',
      online: 'Онлайн',
      offline: 'Офлайн',
      training: 'Навчання',
      uploading: 'Завантаження',
      failed: 'Помилка',
      unknown: 'Невідомо',
      missing: 'Відсутнє'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Базовий часовий ряд порожній',
      insufficient_history: 'Недостатньо історії',
      missing_machine_learning_frame: 'Відсутній набір даних ML',
      missing_prediction_frame: 'Відсутній ряд прогнозів',
      stale_prediction_frame: 'Ряд прогнозів застарів',
      missing_online_model: 'Немає моделі онлайн',
      model_offline: 'Модель офлайн',
      missing_model_blob: 'Відсутній blob моделі',
      missing_model_header: 'Відсутній заголовок моделі',
      missing_modelstatus_entry: 'Відсутній запис modelstatus',
      inference_not_writing_prediction: 'Інференс не записує прогнози',
      prediction_disabled_by_admin: 'Прогноз призупинено адміністратором'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'готові інструменти без результатів прогнозу',
      instruments_waiting_for_history: 'інструменти, що досі очікують на історію',
      models_missing_artifacts: 'моделі онлайн без повних артефактів',
      no_online_models: 'В Azurite немає моделей онлайн',
      azurite_unavailable: 'Стан сховища Azurite наразі недоступний'
    },
    mailTitle: 'Налаштування пошти',
    usersTitle: 'Керування користувачами',
    usersSubtitle: 'Облікові записи, ролі, статус і 2FA з Keycloak. Вибір запису відкриває керування саме цим обліковим записом.',
    usersHideCreate: 'Закрити форму',
    usersCreateHint: 'Новий обліковий запис починається з обовʼязкової 2FA і стає активним після її налаштування.',
    usersFilterAllStatus: 'Усі стани',
    usersFilterAllRoles: 'Усі ролі',
    usersManage: 'Керувати',
    usersClose: 'Закрити',
    usersNoneFound: 'Користувачів не знайдено.',
    usersPagePrev: 'Назад',
    usersPageNext: 'Далі',
    auditTitle: 'Журнал аудиту',
    smtpHost: 'Сервер SMTP',
    smtpPort: 'Порт SMTP',
    smtpSecurity: 'Захист SMTP',
    smtpUsername: 'Користувач SMTP',
    smtpPassword: 'Пароль SMTP',
    fromEmail: 'Адреса відправника',
    fromName: 'Імʼя відправника',
    replyToEmail: 'Адреса для відповіді',
    saveMailSettings: 'Зберегти налаштування пошти',
    sendTestMail: 'Надіслати тестовий лист',
    createUser: 'Створити користувача',
    setPassword: 'Задати пароль',
    setRoles: 'Задати ролі',
    setStatus: 'Задати статус',
    resetMfa: 'Скинути 2FA',
    revokeSessions: 'Відкликати сесії',
    filterUsers: 'Фільтрувати користувачів',
    testRecipient: 'Отримувач тестового листа',
    statusConfigured: 'Налаштовано',
    statusMissing: 'Не налаштовано',
    userEmail: 'Ел. пошта',
    userName: 'Імʼя користувача',
    userRoles: 'Ролі',
    userStatus: 'Статус',
    auditEvent: 'Подія',
    auditCreatedAt: 'Створено',
    auditDetails: 'Деталі',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Кінцева точка',
    aiGatewayIdentitySource: 'Ідентичність із claim токена',
    aiGatewayBudgetSource: 'Початкові значення в',
    aiGatewayModels: 'Маршрутизовані моделі',
    aiGatewayModel: 'Модель',
    aiGatewayBackend: 'Бекенд',
    aiGatewayBudgets: 'Бюджети токенів',
    aiGatewayIdentity: 'Ідентичність',
    aiGatewayTokenBudget: 'Бюджет токенів',
    aiGatewayWindow: 'Вікно',
    aiGatewayAnyIdentity: 'будь-яка ідентичність',
    aiGatewayAnyModel: 'будь-яка модель',
    aiUsageWindowStarted: 'Вікно від',
    aiUsageRemaining: 'Залишок',
    aiUsageIdentities: 'Ідентичності',
    aiGatewaySubtitle: 'Envoy AI Gateway — єдиний шлях до моделі: маршрутизовані моделі, їхні обслуговуючі бекенди та бюджет токенів кожної ідентичності.',
    aiGatewayHint: 'Бюджетами керують тут. Шар розгортання лише задає початкові значення для нового кластера.',
    aiUsageTitle: 'Використання ШІ за ідентичністю',
    aiUsageSubtitle: 'Токени, зараховані шлюзом у поточному вікні.',
    sessionActiveUsers: 'Користувачі в системі',
    sessionActiveSessions: 'Активні сесії',
    sessionMfaSessions: 'Підтверджені сесії',
    aiUsageTotalTokens: 'Усього токенів',
    aiServicesTitle: 'Доступ до сервісів',
    aiServicesSubtitle: 'Посилання на API та експлуатаційні інтерфейси платформи; кожна ціль сама перевіряє роль адміністратора.',
    aiMailSubtitle: 'Налаштування SMTP, через які Keycloak надсилає листи підтвердження та скидання, і тестова розсилка.',
    tabOverview: 'Огляд',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Надсилання пошти',
    tabUsers: 'Користувачі',
    tabAudit: 'Журнал аудиту',
    tabServiceLinks: 'Доступ до сервісів',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Платформа',
    platformTitle: 'Стан платформи',
    platformSubtitle: 'Кожне навантаження pAIoneer Labs GmbH із готовими репліками, перезапусками та образом — напряму з Kubernetes.',
    platformHostPage: 'Керувати екземплярами в хості застосунків',
    openVisitorMonitoring: 'Відкрити моніторинг відвідувачів, маркетингу та SEO',
    platformUnavailable: 'Стан платформи недоступний',
    platformWorkloadsTotal: 'Навантаження',
    platformDegradedTotal: 'Не готові',
    platformRestartsTotal: 'Перезапуски',
    platformWorkload: 'Навантаження',
    platformNamespace: 'Простір імен',
    platformReplicas: 'Репліки',
    platformRestarts: 'Перезапуски',
    platformImage: 'Образ',
    platformState: 'Стан',
    platformStateReady: 'Готове',
    platformStateDegraded: 'Погіршене',
    platformStateDown: 'Зупинене',
    platformStateUnknown: 'Невідоме',
    platformNodes: 'Вузли',
    platformOsImage: 'Операційна система',
    platformKernel: 'Ядро',
    platformRuntime: 'Середовище контейнерів',
    platformKubelet: 'Kubelet',
    platformUsed: 'Використовується зараз',
    platformReportedCapacity: 'За даними Kubernetes',
    platformConfiguredCap: 'Заданий ліміт контейнера',
    platformPressure: 'Умови навантаження',
    platformPressureNone: 'немає',
    platformCpu: 'Ядра CPU',
    platformNoWorkloads: 'Цей простір імен містить обʼєкти конфігурації, без навантажень.',
    platformMemory: 'Памʼять',
    platformEvents: 'Останні попередження',
    platformEventsNone: 'Попереджень немає.',
    platformEventObject: 'Обʼєкт',
    platformEventReason: 'Причина',
    platformEventMessage: 'Повідомлення',
    platformEventLastSeen: 'Востаннє помічено',
    platformMetricsMissing: 'Немає даних про споживання: metrics-server не відповідає.',
    aiGatewayBackends: 'Обслуговуючі бекенди',
    gpuTitle: 'Відеокарта',
    gpuNote: 'Навантаження рушіїв на відеокарті, узяті з них токени за ідентичністю та за ботом Webex, а також бюджети токенів за ідентичністю та рушієм.',
    gpuTokensWindow: 'Токени на відеокарті у вікні',
    gpuSinceStart: 'з моменту запуску рушія',
    gpuIdentities: 'За ідентичністю, поточне вікно',
    gpuBots: 'За ботом Webex і агентом, 30 днів',
    gpuBot: 'Бот Webex / агент',
    gpuBudgetTitle: 'Бюджет на рушій за ідентичністю',
    gpuBudgetSet: 'Встановити бюджет',
    gpuBudgetHint: 'Токенів на годину на рушії; шлюз це забезпечує. Обмежує також ідентичність без ліміту.',
    gpuNoneYet: 'Ще нічого не обліковано.',
    gpuEngines: 'Рушії',
    gpuEngine: 'Рушій',
    gpuEngineGold: 'Золотий рушій',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Середовище виконання, база знань, підготовка навчання та відстежуваність застосунку Agentic RAG.',
    agenticRagBackendStatus: 'Стан бекенду',
    agenticRagRuntimeMode: 'Режим виконання',
    agenticRagKnowledgeMode: 'Режим знань',
    agenticRagDeploymentEnv: 'Середовище розгортання',
    agenticRagVectorStores: 'Векторні сховища',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Колекція документів',
    agenticRagQdrantCuratedCollection: 'Колекція відібраних запитань і відповідей',
    agenticRagQdrantDashboard: 'Панель',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Відкрити Swagger',
    agenticRagOpenPhoenix: 'Відкрити Phoenix',
    agenticRagOpenQdrant: 'Відкрити Qdrant',
    agenticRagKnowledgeTitle: 'База знань',
    agenticRagKnowledgeSubtitle: 'Стан документів і відібраних запитань та відповідей застосунку Agentic RAG.',
    agenticRagDocuments: 'Документи',
    agenticRagCuratedQaPairs: 'Відібрані пари запитання-відповідь',
    agenticRagTrainingTitle: 'Підготовка навчання',
    agenticRagTrainingSubtitle: 'Останній запуск генератора та останній стан тренера.',
    agenticRagLatestDataset: 'Останній набір даних',
    agenticRagDatasetPairs: 'Пари запитання-відповідь',
    agenticRagDatasetDocuments: 'Оброблені документи',
    agenticRagDatasetModifiedAt: 'Остання зміна',
    agenticRagLatestTrainerInput: 'Останні вхідні дані тренера',
    agenticRagTrainerInputModifiedAt: 'Вхідні дані змінено',
    agenticRagLatestTrainerRun: 'Останній запуск тренера',
    agenticRagTrainerRunModifiedAt: 'Підсумок запуску змінено',
    gpuEngineSilver: 'Срібний рушій',
    gpuAssignment: 'Розподіл',
    gpuWho: 'Хто',
    gpuRank: 'Ранг',
    gpuRankHint: 'Ранг 0 обслуговується першим; кожен рушій обслуговує за рангом.',
    gpuLanes: 'Поточні виклики Veridion Core за рушієм і рангом',
    gpuInFlight: 'виконуються',
    gpuWhoMainBotPeople: 'Головний бот: розмови з людьми',
    gpuWhoMainBotJudgements: 'Головний бот: судження в тому ж ході',
    gpuWhoAutopilot: 'Автопілот',
    gpuWhoAgents: 'Агенти, яких запускає головний бот',
    gpuWhoArchitect: 'Архітектор',
    gpuWhoChair: 'Головування на нараді',
    gpuWhoOrchestrator: 'Оркестратор інстанції компанії',
    gpuWhoColleagues: 'ШІ-колеги: ходи та їхні судження',
    gpuWhoMeetingWords: 'ШІ-колеги: виступи на нарадах',
    gpuWhoBackgroundReading: 'Фонова служба: читання дописів ботів',
    gpuWhoMemory: 'Пам\'ять компанії: прийняття та брифи',
    gpuWhoCoding: 'Завдання з кодування: судження та навчання',
    gpuWhoResearch: 'Веб- та OSINT-дослідження',
    gpuWhoKnowledgeBase: 'База знань компанії: читання відсканованих сторінок',
    gpuWhoPipeline: 'Перевірка пайплайна за IDD',
    gpuWhoSmtm: 'Veridion SMTM: чат і база знань SaaS, останній ранг',
    gpuUnavailable: 'Відеокарта не відповідає',
    aiGatewaySource: 'Джерело',
    aiSourceGpu: 'Відеокарта',
    aiGatewayMeter: 'Лічильник',
    aiGatewayMeterIdentity: 'Кожна ідентичність, підраховано',
    aiGatewayEngines: 'Рушії на відеокарті',
    aiGatewayEnginesHint: 'Поточні показники кожного рушія з його метрик: запити, що виконуються й чекають, заповненість кешу та токени, обслужені з моменту запуску.',
    aiEngineRunning: 'Виконуються',
    aiEngineWaiting: 'Очікують',
    aiEngineCache: 'Кеш зайнято',
    aiEngineServed: 'Обслужено токенів',
    aiEngineIdle: 'Немає запитів',
    aiEngineUnavailable: 'Рушій не відповідає',
    aiGatewayServing: 'Готовий',
    aiBudgetControlTitle: 'Керування бюджетами токенів',
    aiBudgetControlSubtitle: 'Типовий бюджет діє для кожної ідентичності. Окрема ідентичність може мати власну межу.',
    aiBudgetDefault: 'Типовий бюджет',
    aiBudgetIdentity: 'Ідентичність',
    aiBudgetTokens: 'Токени',
    aiBudgetApply: 'Застосувати',
    aiBudgetAdd: 'Задати межу',
    aiBudgetRemove: 'Видалити',
    aiBudgetSaved: 'Бюджет токенів застосовано.',
    aiBudgetIdentityPlaceholder: 'Ідентифікатор клієнта, напр. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Без ліміту',
    aiBudgetSetUnlimited: 'Зняти ліміт',
    aiBudgetRestoreLimit: 'Відновити ліміт',
    aiUsageReset: 'Очистити вікно',
    aiUsageResetDone: 'Поточне вікно очищено.',
    userMfa: '2FA',
    userMfaOn: 'Налаштовано',
    userMfaOff: 'Відсутня',
    userCreatedAt: 'Створено',
    mailSource: 'Керується в',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Розмовне ядро торгового асистента: середовище виконання, реєстр інструментів, MCP-сервери та активність.',
    veridionOpenPage: 'Відкрити Veridion',
    veridionOpenDocs: 'Відкрити Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Інструменти',
    veridionToolsTitle: 'Реєстр інструментів',
    veridionToolsSubtitle: 'Показує завантажені родини інструментів і їхній фактичний стан.',
    veridionToolName: 'Інструмент',
    veridionToolRuntime: 'Середовище',
    veridionToolRisk: 'Ризик',
    veridionToolEnabled: 'Увімкнено',
    veridionNoTools: 'Інструменти Veridion не завантажено.',
    veridionRuntimeProfiles: 'Профілі середовища',
    veridionRegistryReloaded: 'Реєстр перезавантажено',
    veridionProvider: 'Шлях ШІ',
    veridionMcpTitle: 'MCP-сервери',
    veridionMcpSubtitle: 'Підключені зовнішні сервери інструментів зі станом і кількістю інструментів.',
    veridionMcpServer: 'Сервер',
    veridionMcpState: 'Стан',
    veridionMcpTools: 'Інструменти',
    veridionMcpLastSuccess: 'Востаннє досяжний',
    veridionMcpConnected: 'підключено',
    veridionMcpUnreachable: 'недоступний',
    veridionMcpDisabled: 'вимкнено',
    veridionMcpEmpty: 'MCP-сервери не налаштовано.',
    veridionActivityTitle: 'Стрічка активності',
    veridionActivitySubtitle: 'Структуровані події виконання з оркестратора та його інструментів.',
    veridionActivityEmpty: 'Активності ще не зафіксовано.',
    veridionActivitySource: 'Джерело',
    veridionActivitySurface: 'Поверхня',
    veridionActivityEvent: 'Подія',
    veridionActivityTool: 'Інструмент',
    veridionActivityStatus: 'Статус',
    veridionActivitySummary: 'Підсумок',
    veridionUnavailable: 'Veridion наразі недоступний.',
    veridionNotConfigured: 'Veridion ще не повністю налаштовано в середовищі Homepage.',
    veridionRequestFailed: 'Veridion не завершив запитаний адміністративний виклик успішно.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'Екземпляр Veridion компанії pAIoneer Labs GmbH для співробітників у Webex, з YouTrack і власною базою знань; його виклики моделей проходять через Envoy AI Gateway.',
    companyWorkloads: 'Робочі навантаження',
    companyTokensWindow: 'Токени в поточному вікні',
    companyBudget: 'Бюджет',
    companyBudgetDefault: 'типовий бюджет',
    companyCost30: 'Витрати за останні 30 днів',
    openrouterTitle: 'Нараховано OpenRouter',
    openrouterRemaining: 'Залишок кредиту',
    openrouterOf: 'з',
    openrouterToday: 'Сьогодні',
    openrouterWeek: 'Цього тижня',
    openrouterMonth: 'Цього місяця',
    openrouterUnavailable: 'OpenRouter зараз недоступний для читання',
    openrouterNote: 'Рахунок OpenRouter для ключа платформи, у доларах США; день і тиждень за UTC. Облікові значення нижче враховують лише відповіді, що повідомляють свою вартість, тому вони менші.',
    companyRequests30: 'Виклики моделі за останні 30 днів',
    companyCostNote: 'Витрати в доларах США за даними OpenRouter для кожного запиту; токени Envoy AI Gateway записує на ідентичність {identity}.',
    companyCostNotReported: 'не повідомлено',
    companyPartUnavailable: 'недоступно',
    companyWebexTitle: 'Webex-бот',
    companyWebexSubtitle: 'Webex викликає webex.paioneer-labs.eu/hook; міст перевіряє підпис і відправника та передає Veridion лише дозволені повідомлення.',
    companyWebexBot: 'Бот',
    companyWebexWebhook: 'Вебхук',
    companyWebexRegistered: 'зареєстровано',
    companyWebexNotRegistered: 'не зареєстровано',
    companyWebexAccess: 'Дозволено',
    companyWebexAnswered: 'Відповіді',
    companyWebexRejected: 'Відхилено',
    companyWebexFailed: 'Невдалі',
    companyWebexRecent: 'Останні доставки',
    companyWebexTime: 'Час',
    companyWebexOutcome: 'Результат',
    companyWebexReason: 'Причина',
    companyWebexSender: 'Відправник',
    companyWebexEmpty: 'Від останнього запуску доставок не було.',
    companyWebexNotConfigured: 'Міст Webex недоступний або в admin API бракує його ключа статусу.',
    companyUsageTitle: 'Використання за особами',
    companyUsageSubtitle: 'Виклики моделі, токени й витрати за останні 30 днів із журналу використання екземпляра.',
    companyUsagePerson: 'Особа',
    companyUsageCalls: 'Виклики',
    companyUsageTokens: 'Токени',
    companyUsageCost: 'Витрати (USD)',
    companyUsageEmpty: 'За останні 30 днів викликів моделі не було.',
    companyWebexSendTitle: 'Написати від імені бота',
    companyWebexSendPerson: 'Особі',
    companyWebexSendRoom: 'У кімнату бота',
    companyWebexSendEmail: 'Адреса електронної пошти у Webex',
    companyWebexSendText: 'Повідомлення (Markdown)',
    companyWebexSendButton: 'Надіслати',
    companyWebexSendDone: 'Надіслано.',
    companyWebexSendFailed: 'Не вдалося',
    companyWebexRooms: 'Кімнати бота',
    companyWebexRoomGroup: 'група',
    companyWebexRoomDirect: 'особиста',
    companyWebexRoomsEmpty: 'Бот ще не входить до жодної кімнати.',
    companyKnowledgeTitle: 'База знань',
    companyKnowledgeSubtitle: 'Документи бази знань корпоративного екземпляра (Agentic RAG); оркестратор шукає в них, коли цього потребує крок розмови. Phoenix фіксує кожен пошук.',
    companyKnowledgeDocument: 'Документ',
    companyKnowledgeSize: 'Розмір',
    companyKnowledgeModified: 'Додано',
    companyKnowledgeDelete: 'Видалити',
    companyKnowledgeDeleteConfirm: 'Видалити {name} з бази знань?',
    companyKnowledgeUpload: 'Додати документ',
    companyKnowledgeUploading: 'Завантаження …',
    companyKnowledgeIntake: 'Обробка',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'База знань порожня.',
    companyKnowledgeNotConfigured: 'База знань не підключена до admin API.',
    companyGuestsTitle: 'Гості з доступом',
    companyGuestsHint: 'Будь-яка адреса в {domains} може користуватися ботом. Окремі зовнішні адреси адміністратори додають тут; зміна діє одразу.',
    companyGuestsEmail: 'Адреса e-mail',
    companyGuestsAdd: 'Додати',
    companyGuestsRemove: 'Видалити',
    companyGuestsRemoveConfirm: 'Відкликати доступ {email} до бота?',
    companyGuestsAddedBy: 'Додав',
    companyGuestsAddedAt: 'Додано',
    companyGuestsEmpty: 'Гостей не додано.',
    companyGuestsNotPersistent: 'Список не зберігається: міст не має каталогу даних.',
    companyGuestsLoadFailed: 'Збережений список не вдалося прочитати; до наступної зміни жоден гість не має доступу.',
    companyErrorRecipientNotAllowed: 'Ця адреса не може відповідати боту. Спочатку додайте її як гостя, потім надсилайте.',
    companyErrorDomainAllowed: 'Адреси цього домену вже мають доступ.',
    companyErrorInvalidEmail: 'Недійсна адреса e-mail.',
    companyErrorAlreadyListed: 'Ця адреса вже є у списку.',
    companyErrorStoreUnwritable: 'Не вдалося зберегти список.',
    smtmFilterTitle: 'Фільтр інструментів SMTM',
    smtmFilterSubtitle: 'Порожнє поле показує всі інструменти; кілька назв інструментів розділяються комою, наприклад EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Назви інструментів через кому',
    smtmFilterApply: 'Застосувати фільтр',
    smtmFilterClear: 'Очистити фільтр',
    smtmReportingTitle: 'Звітність за сигналами SMTM',
    smtmReportingSubtitle: 'Показує кваліфіковані сигнали купівлі, оцінку їх виходу та стан доставки автоматичних сповіщень.',
    smtmReportingUnavailable: 'Звітність SMTM недоступна',
    smtmReportingQualifiedSignals: 'Кваліфіковані сигнали',
    smtmReportingOpenSignals: 'Відкриті сигнали',
    smtmReportingResolvedSignals: 'Закриті сигнали',
    smtmReportingWins: 'Успіхи',
    smtmReportingLosses: 'Втрати',
    smtmReportingWinRate: 'Частка успіхів',
    smtmReportingAverageActualReturn: 'Середня фактична дохідність',
    smtmReportingNetActualReturn: 'Чиста фактична дохідність',
    smtmReportingDeliveryFailed: 'Невдалі доставки',
    smtmReportingEntryTime: 'Час входу',
    smtmReportingExitTime: 'Час виходу',
    smtmReportingExpectedReturn: 'Очікувана дохідність',
    smtmReportingActualReturn: 'Фактична дохідність',
    smtmReportingSignalStatus: 'Стан сигналу',
    smtmReportingNoSignals: 'Кваліфікованих сигналів ще не збережено.',
    smtmReportingPendingDeliveries: 'Доставки в очікуванні',
    smtmReportingFailedDeliveries: 'Невдалі доставки',
    smtmReportingDeliveryError: 'Помилка доставки',
    smtmTrainingTitle: 'Навчання та моделі SMTM',
    smtmTrainingSubtitle: 'Показує якість навчання, стан моделей і артефакти, опубліковані сервісом навчання.',
    smtmTrainingUnavailable: 'Навчання SMTM недоступне',
    smtmTrainingModels: 'Моделі',
    smtmTrainingOnlineModels: 'Моделі онлайн',
    smtmTrainingFailedModels: 'Невдалі моделі',
    smtmTrainingStaleModels: 'Застарілі моделі',
    smtmTrainingAverageMae: 'Середній MAE',
    smtmTrainingAverageRmse: 'Середній RMSE',
    smtmTrainingAverageR2: 'Середній R²',
    smtmTrainingAverageMase: 'Середній MASE',
    smtmTrainingAverageHitRate: 'Середня точність напрямку',
    smtmTrainingHitRate: 'Точність напрямку',
    smtmTrainingLastSuccess: 'Останнє успішне навчання',
    smtmTrainingResolution: 'Роздільність / горизонт',
    smtmTrainingConsoleTitle: 'Консоль навчання SMTM',
    smtmTrainingConsoleSubtitle: 'Живий перегляд виводу сервісу навчання.',
    smtmTrainingConsoleUnavailable: 'Консоль навчання SMTM недоступна',
    smtmTrainingConsoleEmpty: 'Виводу навчання ще немає.',
    smtmRuntimeTitle: 'Середовище SMTM',
    smtmRuntimeSubtitle: 'Глобальний горизонт, стан перебудови та шлюз прогнозів робочої системи SMTM.',
    smtmRuntimeUnavailable: 'Середовище SMTM недоступне',
    smtmRuntimeForecastHorizon: 'Горизонт прогнозу',
    smtmRuntimeResolution: 'Роздільність',
    smtmRuntimeConfigVersion: 'Версія конфігурації',
    smtmRuntimePredictionGate: 'Шлюз прогнозів',
    smtmRuntimeRebuild: 'Перебудова',
    smtmRuntimeStateOpen: 'відкрито',
    smtmRuntimeStateClosed: 'закрито',
    smtmRuntimeStateActive: 'активна',
    smtmRuntimeStateIdle: 'неактивна',
    smtmRuntimeForecastHorizonMinutes: 'Горизонт прогнозу у хвилинах',
    smtmRuntimeResolutionMinutes: 'Роздільність у хвилинах',
    smtmRuntimeRequireCompletedBars: 'Вимагати завершені свічки',
    smtmRuntimePredictionGateOpen: 'Шлюз прогнозів відкрито',
    smtmRuntimeRebuildActive: 'Перебудова активна',
    smtmRuntimeSaving: 'Збереження середовища...',
    smtmRuntimeSave: 'Зберегти налаштування середовища',
    smtmRuntimeReset: 'Скасувати зміни середовища',
    smtmRuntimeSaved: 'Налаштування середовища SMTM збережено.',
    smtmTrainingRows: 'Рядки навчання / тесту',
    smtmTrainingMetrics: 'Метрики',
    smtmTrainingIssues: 'Проблеми навчання',
    smtmTrainingLlmFeatures: 'Ознаки LLM',
    smtmTrainingNoModels: 'Кешованих моделей навчання ще немає.',
    smtmDirection: 'Напрям',
    smtmSentiment: 'Настрій',
    smtmDeliveryStage: 'Етап',
    smtmDeliveryRecipient: 'Отримувач',
    mailSettingsSaved: 'Налаштування пошти збережено.',
    mailTestSent: 'Тестовий лист надіслано.',
    userCreatedSuccess: 'Користувача створено успішно.',
    userUpdatedSuccess: 'Користувача оновлено успішно.',
    userDeletedSuccess: 'Користувача видалено успішно.',
    deleteUser: 'Видалити користувача',
    roleLabels: {
      admin: 'Адміністратор',
      pro: 'Pro',
      tester: 'Тестувальник',
      user: 'Користувач'
    },
    statusLabels: {
      pending_email_verification: 'Очікує підтвердження пошти',
      pending_mfa: 'Очікує 2FA',
      active: 'Активний',
      locked: 'Заблокований',
      disabled: 'Вимкнений'
    }
  },
  footer: {
    managingDirectors: 'Керуючі директори',
    servicesTitle: 'Послуги',
    legal: {
      title: 'Правова інформація',
      imprint: 'Вихідні дані',
      privacy: 'Політика конфіденційності',
      aiTransparency: 'Прозорість у сфері ШІ',
      cookieSettings: 'Налаштування файлів cookie',
      terms: 'Умови надання послуг'
    },
    copyright: 'Усі права захищено.'
  },
  auth: {
    validating: 'Перевірка...',
    errors: {
      registrationFailed: 'Реєстрація не вдалася: ',
      unknownError: 'Невідома помилка'
    }
  },
  account: {
    username: 'Імʼя користувача',
    email: 'Електронна пошта',
    roles: 'Ролі',
    manageText: 'Пароль, двофакторну автентифікацію, активні сеанси та адресу електронної пошти ви змінюєте в керуванні обліковим записом.',
    manageButton: 'Відкрити керування обліковим записом',
    signedOut: 'Ви не увійшли в систему.'
  },
  cookies: {
    title: 'Налаштування конфіденційності',
    description: 'Ми аналізуємо статистику відвідувань методами машинного навчання, щоб покращувати наш вебсайт. За вашою згодою ми обробляємо для цього дані про використання та пристрій, зокрема вашу IP-адресу, і розпізнаємо ваш браузер під час наступних відвідувань. Згода є добровільною, і її можна будь-коли відкликати в розділі «{settings}». Подробиці, зокрема щодо передачі до третіх країн, наведено в політиці конфіденційності.',
    necessary: {
      title: 'Необхідні',
      description: 'Потрібні для роботи вебсайту, наприклад вибір мови та збереження цього вибору.'
    },
    statistics: {
      title: 'Статистика',
      description: 'Перегляди сторінок і використання вебсайту без розпізнавання та без збереження IP-адреси.'
    },
    marketing: {
      title: 'Аналіз і машинне навчання',
      description: 'Розпізнавання під час наступних відвідувань і аналіз IP-адреси (приблизне місцезнаходження, оператор мережі, організація) та характеристик пристрою; зберігається до дванадцяти місяців після останнього відвідування. При цьому ваша IP-адреса передається також інтернет-реєстраторам у США, Австралії та на Маврикії, щодо яких не встановлено адекватного рівня захисту даних; існує ризик доступу органів влади цих країн і ускладненої реалізації ваших прав.'
    },
    acceptAll: 'Прийняти все',
    rejectAll: 'Лише необхідні',
    settings: 'Налаштування',
    save: 'Зберегти вибір',
    alwaysOn: 'Завжди активні'
  },
  pages: {
    teaching: {
      hero: {
        title: 'Навчання з периферійного ШІ (Edge AI) та EU AI Act',
        subtitle: 'Консультування з корпоративного ШІ • Розробка периферійних рішень • Юридично надійне впровадження'
      },
      intro: 'Спеціалізоване навчання із ШІ для керівництва компаній, керівників проєктів і команд розробки. Від стратегічного консультування до технічного впровадження — відповідно до EU AI Act.',
      eu_ai_act: {
        title: 'Відповідність EU AI Act і периферійні обчислення',
        subtitle: 'Юридично надійне впровадження ШІ з локальною обробкою даних',
        description: 'EU AI Act встановлює суворі правила використання штучного інтелекту в Європі. Периферійні обчислення (Edge Computing) пропонують ідеальне рішення: чутливі дані залишаються локальними, дотримання вимог спрощується, а контроль над системами ШІ залишається у ваших руках.',
        benefits: ['Захист даних завдяки локальній обробці', 'Простіше дотримання нормативних вимог', 'Повний контроль над рішеннями, які ухвалює ШІ', 'Прозорість і простежуваність', 'Мінімальні юридичні ризики', 'Незалежність від хмарних провайдерів'],
        highlight: 'Периферійні обчислення + EU AI Act = юридично надійний ШІ без компромісів'
      },
      offerings: {
        title: 'Навчальні програми',
        categories: [
          { title: 'Штучний інтелект і машинне навчання', icon: 'brain', topics: ['Генеративний ШІ та великі мовні моделі (периферія та хмара)', 'Класичне машинне навчання (оптимізоване для периферійних пристроїв)', 'Глибоке навчання та нейронні мережі (розгортання на периферійних пристроях)', 'Комп’ютерний зір і NLP (рішення для периферійних пристроїв)', 'RAG-системи та донавчання LLM (периферія та хмара)', 'Автономні ШІ-агенти (периферійні обчислення)', 'Відповідність EU AI Act і правова визначеність'] },
          { title: 'Наука про дані та статистика', icon: 'chart', topics: ['Описова статистика та статистичне висновування', 'Моделювання та аналіз даних', 'Аналіз часових рядів', 'Економетрика для бізнесу та економіки', 'Біостатистика для природничих наук', 'A/B-тестування та планування експериментів'] },
          { title: 'Архітектура програмного забезпечення та безпека', icon: 'shield', topics: ['Модульні архітектури', 'Слабка зв’язаність і чистий код', 'Проєктування мікросервісів', 'ІТ-безпека та відповідність вимогам', 'DevOps і CI/CD', 'Хмарні архітектури'] }
        ]
      },
      target_groups: {
        title: 'Цільові групи',
        groups: [
          { title: 'Вище керівництво та особи, які ухвалюють рішення', description: 'Стратегічне консультування із ШІ, аналіз витрат та інвестиційні рішення', formats: ['Брифінги для керівництва', 'Аналіз ROI', 'Стратегічне консультування'], focus: 'Бізнес-кейси, відповідність EU AI Act, планування бюджету' },
          { title: 'Керівники проєктів і менеджери', description: 'Управління проєктами ШІ, вибір технологій і стратегії впровадження', formats: ['Воркшопи для менеджменту', 'Оцінювання технологій', 'Розробка дорожньої карти'], focus: 'Планування проєктів, вибір постачальників, управління ризиками' },
          { title: 'ІТ-розробники та інженери', description: 'Практична розробка рішень периферійного ШІ, технічне впровадження та розгортання', formats: ['Поглиблені технічні сесії', 'Рев’ю коду', 'Архітектурні воркшопи'], focus: 'Периферійні обчислення, донавчання LLM, системна інтеграція' },
          { title: 'Фахівці профільних підрозділів', description: 'Розуміння ШІ, техніки промптингу та практичне застосування в щоденній роботі', formats: ['Навчання користувачів', 'Воркшопи з промптингу', 'Розробка сценаріїв використання'], focus: 'Практичне застосування, інтеграція в робочі процеси, підвищення продуктивності' },
          { title: 'Студенти та науковці', description: 'Університетське викладання, репетиторство та супровід наукових проєктів', formats: ['Лекції', 'Репетиторство', 'Супровід дипломних і дисертаційних робіт'], focus: 'Статистика, економетрика, методи досліджень' }
        ]
      },
      expertise: {
        title: 'Технічна компетентність',
        items: ['Розробка стратегічних дорожніх карт ШІ для підприємств', 'Системи периферійного ШІ з архітектурами RAG/GRAG і донавчанням LoRA/QLoRA', 'Стратегії відповідності EU AI Act і юридично надійне впровадження', 'Аналіз ROI та інвестиційне планування для проєктів ШІ', 'Автономні ШІ-агенти з наборами інструментів і здатністю до міркування', 'Управління змінами під час впровадження ШІ в організаціях', 'Хмарні та локальні стратегії (Azure, STACKIT)', 'Промпт-інженерія та оптимізація робочих процесів']
      },
      technologies: {
        title: 'Технологічний стек',
        list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata'
      },
      clients: {
        title: 'Галузі та установи',
        sectors: ['Медичне страхування', 'Видавництва', 'Банки та фінтех', 'Промисловість та IoT', 'Наука та університети', 'Консалтинг', 'Стартапи']
      },
      workshops: {
        title: 'Варіанти форматів',
        formats: [
          { title: 'Брифінг для керівництва', duration: '2–4 години', description: 'Стратегічний огляд для керівництва з акцентом на ROI та EU AI Act' },
          { title: 'Воркшоп для менеджменту', duration: '1–2 дні', description: 'Навчання керівників проєктів із впровадження ШІ та управління змінами' },
          { title: 'Поглиблена технічна сесія', duration: '2–5 днів', description: 'Практична розробка рішень периферійного ШІ для ІТ-команд та інженерів' },
          { title: 'Навчання користувачів', duration: '0,5–1 день', description: 'Практичне застосування ШІ для фахівців профільних підрозділів' },
          { title: 'Індивідуальний коучинг', duration: 'За потреби', description: 'Особистий супровід і допомога в проєктах' }
        ]
      },
      sidebar: {
        languagesLabel: 'Мови:',
        languagesValue: 'DE / EN / NL',
        focusLabel: 'Основні теми:',
        specializationTitle: 'Спеціалізація',
        specializationItems: ['Периферійний ШІ для локальної обробки даних без залежності від хмари', 'Впровадження відповідно до EU AI Act для правової визначеності'],
        benefitsTitle: 'Переваги',
        benefits: ['Адаптовано до цільової групи', 'Можна застосувати одразу', 'Орієнтація на ROI', 'Дистанційно або на місці']
      },
      cta: {
        title: 'Готові до стратегічної трансформації на основі ШІ?',
        description: 'Від консультування керівництва до технічного впровадження — обговорімо ваші конкретні вимоги.',
        button: 'Замовити консультацію',
        email: 'info@paioneer.eu',
        subject: 'Запит щодо навчання'
      }
    },
    agenticdev: {
      seo: {
        title: 'Intent-Driven Development (IDD) для агентного програмування | pAIoneer Labs GmbH',
        description: 'Intent-Driven Development робить розробку програмного забезпечення з підтримкою ШІ керованою: сенс, рішення та сценарії стають операційними артефактами для агентного програмування.',
        keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, агентне програмування, агентна розробка програмного забезпечення, розробка програмного забезпечення з підтримкою ШІ, Vibe Coding, Spec-Driven Development, промпт-інженерія, інженерія вимог із ШІ',
        ogTitle: 'Intent-Driven Development: спершу сенс, потім реалізація',
        ogDescription: 'IDD робить контекст робочим інструментом ще до написання коду: Intent, Decisions і Scenarios стають пам’яттю проєкту для агентної розробки програмного забезпечення.',
        twitterTitle: 'Intent-Driven Development (IDD) для агентного програмування',
        twitterDescription: 'Керований код замість хаосу промптів: IDD перетворює сенс, рішення та сценарії на операційні артефакти.',
        url: 'https://paioneer-labs.eu/agenticdev',
        structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) для агентного програмування', serviceType: 'Агентна розробка програмного забезпечення та процеси розробки з підтримкою ШІ', description: 'Консультування та впровадження Intent-Driven Development, IDD Vaults, робочих процесів агентного програмування та перевірної розробки програмного забезпечення з підтримкою ШІ.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' }
      },
      hero: { eyebrow: 'Агентному програмуванню потрібен явний контекст', title: 'Intent-Driven Development', claim: 'Спершу сенс, потім реалізація.', lead: 'ШІ пише код. IDD дбає про те, щоб він працював над правильною проблемою. Intent-Driven Development перетворює цілі, межі, рішення та сценарії на операційні артефакти для агентної розробки програмного забезпечення.' },
      implicitContextProblem: { title: 'Ризик — у неявному контексті', intro: 'Справжній ризик розробки програмного забезпечення з підтримкою ШІ — не брак коду. Ризик — це контекст, який залишається прихованим у чиїйсь голові, в історії чату або в розрізнених тікетах.', items: [{ title: 'Нечітке завдання', description: 'Промпти часто описують рішення, але не мету, нецілі, критерії успіху та припущення. Тоді ШІ працює швидко, але не обов’язково в правильному напрямку.' }, { title: 'Випадкова архітектура', description: 'Технологічні рішення ухвалюються мимохідь: зберігання даних, вибір моделі, сценарії відмов та експлуатація визначаються неявно, замість того щоб ними свідомо керували.' }, { title: 'Результат, який неможливо перевірити', description: 'Без сценаріїв і критеріїв приймання залишається незрозумілим, чи код справді поводиться правильно, чи лише має правдоподібний вигляд.' }], resolution: 'IDD розв’язує саме цю проблему: спочатку сенс переводиться в робочу форму, а вже потім із нього виводиться код.' },
      antiVibeCoding: { title: 'Vibe Coding — це не процес розробки', description: 'Для демонстрацій інтуїції може вистачити. Для програмного забезпечення, яке потребує експлуатації, супроводу, безпеки, контролю витрат і відповідальності, її недостатньо. Агентам потрібен не настрій, а явний контекст.', contrasts: ['Vibe Coding створює рух. IDD створює напрям.', 'Промптинг дає відповіді. IDD створює пам’ять проєкту.', 'Агентне програмування без IDD залишається активністю. Агентне програмування з IDD стає керованою розробкою.'] },
      principle: { title: 'Документація — не побічний продукт', thesis: 'В IDD документація є операційним артефактом.', description: 'Документація — це не звітність. Це робочий простір, у якому цілі, межі, рішення та очікувана поведінка стають явними ще до того, як агенти почнуть реалізацію.', pillarsTitle: 'Намір. Рішення. Сценарії. Код.', pillarsIntro: 'IDD не зводить розробку програмного забезпечення до промптів. Він робить сенс проєкту явним і виводить із нього реалізацію, яку можна перевірити.', pillars: [{ title: 'Намір', description: 'Чого потрібно досягти, що свідомо залишається поза межами завдання і як ми розпізнаємо успіх?' }, { title: 'Рішення', description: 'Які важливі рішення було ухвалено, в якому контексті та з якими наслідками?' }, { title: 'Сценарії', description: 'Яка поведінка очікується у звичайних і граничних випадках, у разі відмов і під час приймання?' }, { title: 'Код', description: 'Реалізація постає із задокументованого сенсу й перевіряється за сценаріями та кроками верифікації.' }] },
      vault: { title: 'IDD Vault: пам’ять проєкту замість історії промптів', description: 'IDD Vault зберігає релевантний контекст там, де агенти й люди можуть використовувати його повторно. Файлів не більше, ніж потрібно. Кожен файл має чітку функцію.', rule: 'Мало артефактів. Чітке призначення. Довговічний контекст.', effect: 'Vault не дає вирішальному контексту зникнути в чаті, у чиїйсь голові чи серед розрізнених тікетів.', treeLines: ['/project', '  /idd_vault', '    intent.md       # мета, нецілі, критерії успіху, припущення', '    decisions.md    # рішення з контекстом, обґрунтуванням, наслідками', '    scenarios.md    # поведінка, граничні випадки, критерії приймання', '  /code', '  AGENTS.md         # правила й очікування для агентів, що пишуть код', '  README.md         # вступ, налаштування, режим роботи, межі'] },
      outputs: { title: 'Не текст. Керований код.', description: 'Файли IDD — це не звіт. Це вхідні дані для конкретної роботи з реалізації та для повернення здобутих висновків назад у проєкт.', items: [{ file: 'intent.md', result: 'Обсяг робіт', description: 'Кінцеві точки API, модель даних, критерії успіху, нецілі та припущення стають видимими як рамка розробки.' }, { file: 'decisions.md', result: 'Архітектура', description: 'Технології, експлуатація, зберігання даних, вибір моделі та компроміси обґрунтовуються, а не визначаються мимохідь.' }, { file: 'scenarios.md', result: 'Тести', description: 'Приймальні тести, сценарії відмов, зміни станів і граничні випадки з’являються до реалізації або під час неї.' }, { file: 'AGENTS.md', result: 'Якість коду', description: 'Правила, шаблони, обмеження, міграції, OpenAPI та очікувані результати стають явними для агентів.' }, { file: 'README.md', result: 'Точка входу', description: 'Налаштування, режим роботи, межі та приклади послідовностей дій залишаються зрозумілими для людей і агентів.' }, { file: 'Код', result: 'Зворотний зв’язок', description: 'Висновки з реалізації та перевірки повертаються до Vault, тестів і наступної ітерації.' }] },
      comparison: { title: 'IDD починається до специфікації', intro: 'Spec-Driven Development сильний тоді, коли мета вже технічно точна і стабільна. IDD починається раніше: там, де предметну область, припущення, компроміси та сценарії відмов ще тільки треба зробити явними.', columns: ['Підхід', 'Центр', 'Сильна сторона', 'Обмеження'], rows: [{ approach: 'Промптинг', center: 'Запит до моделі', strength: 'Швидко й безпосередньо', limit: 'Швидкоплинно, неповно й важко перевірити' }, { approach: 'Vibe Coding', center: 'Інтуїція та ітерації', strength: 'Корисно для експериментів і демонстрацій', limit: 'Немає надійного керування для програмного забезпечення, за яке потрібно відповідати' }, { approach: 'Spec-Driven Development', center: 'Технічний контракт', strength: 'Узгодженість із уже визначеною специфікацією', limit: 'Неправильну проблему можна реалізувати формально правильно' }, { approach: 'Intent-Driven Development', center: 'Сенс, мета та рішення', strength: 'Прояснює контекст, компроміси та межі ще до реалізації', limit: 'Потребує послідовного підтримання контексту та його перевірки' }], summary: 'Специфікації кажуть, що має виконуватися технічно. IDD обґрунтовує, чому слід будувати саме в цьому напрямі.' },
      workflow: { title: 'Прояснити. Вирішити. Сформулювати. Реалізувати. Повернути в проєкт.', description: 'IDD — це не каскадна модель. IDD — це невеликі контрольовані ітерації зі сталим контекстом.', steps: [{ title: 'Прояснити намір', description: 'Цілі, нецілі, критерії успіху та припущення стають видимими ще до написання коду.' }, { title: 'Задокументувати рішення', description: 'Архітектурні та продуктові рішення фіксуються разом із контекстом, обґрунтуванням і наслідками.' }, { title: 'Сформулювати сценарії', description: 'Звичайна поведінка, граничні випадки, сценарії відмов і критерії приймання описуються так, щоб їх можна було перевірити.' }, { title: 'Доручити реалізацію агентам', description: 'ШІ-агенти працюють з явним контекстом, а не з ізольованими промптами.' }, { title: 'Перевірити й повернути в проєкт', description: 'Висновки з коду, тестів та експлуатації оновлюють Vault і наступну ітерацію.' }] },
      impact: { title: 'Чому це важливо для реальних проєктів', description: 'IDD робить розробку з підтримкою ШІ сумісною з роботою команд, експлуатацією та забезпеченням якості.', items: ['Менше переробок, бо цілі та нецілі видно.', 'Краща архітектура, бо рішення обґрунтовано.', 'Кращі тести, бо сценарії існують ще до коду.', 'Краща співпраця, бо контекст не зникає в чаті.', 'Кращі результати агентів, бо кожен крок спирається на явні артефакти.'] },
      contact: { title: 'Впровадьте IDD в агентні процеси розробки', description: 'Якщо розробка з підтримкою ШІ має стати чимось більшим, ніж експеримент, їй потрібна операційна модель контексту.', details: 'Ми допомагаємо вибудовувати IDD Vaults, правила для агентів, сценарії та перевірні процеси розробки.', button: 'Обговорити IDD', subject: 'Обговорити Intent-Driven Development', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('uk', baseTranslationUK)
  }
};
